/*! @wharfkit/protocol-scatter v4.0.1 | BSD-3-Clause | Copyright (c) 2023 Greymass Inc. | https://github.com/wharfkit/js */
import { i as __toCommonJS, n as __esmMin, r as __exportAll, t as __commonJSMin } from "./rolldown-runtime.js";
import { Bytes, Checksum256 } from "@wharfkit/antelope";
//#region ../../node_modules/.bun/isomorphic-ws@4.0.1+a6d2e96c817c22ac/node_modules/isomorphic-ws/browser.js
var require_browser = __commonJSMin(((exports, module) => {
	var ws = null;
	if (typeof WebSocket !== "undefined") ws = WebSocket;
	else if (typeof MozWebSocket !== "undefined") ws = MozWebSocket;
	else if (typeof global !== "undefined") ws = global.WebSocket || global.MozWebSocket;
	else if (typeof window !== "undefined") ws = window.WebSocket || window.MozWebSocket;
	else if (typeof self !== "undefined") ws = self.WebSocket || self.MozWebSocket;
	module.exports = ws;
}));
//#endregion
//#region src/create-hash.ts
var create_hash_exports = __exportAll({ default: () => createHash });
function createHash(algorithm) {
	if (algorithm !== "sha256") throw new Error(`create-hash shim: unsupported algorithm '${algorithm}'`);
	let buffer = "";
	const hash = {
		update(data) {
			if (typeof data !== "string") throw new Error("create-hash shim: only string input is supported");
			buffer += data;
			return hash;
		},
		digest(encoding) {
			if (encoding !== "hex") throw new Error(`create-hash shim: unsupported encoding '${encoding}'`);
			return Checksum256.hash(Bytes.fromString(buffer, "utf8")).hexString;
		}
	};
	return hash;
}
var init_create_hash = __esmMin((() => {}));
//#endregion
//#region ../../node_modules/.bun/global@4.4.0/node_modules/global/window.js
var require_window = __commonJSMin(((exports, module) => {
	var win;
	if (typeof window !== "undefined") win = window;
	else if (typeof global !== "undefined") win = global;
	else if (typeof self !== "undefined") win = self;
	else win = {};
	module.exports = win;
}));
//#endregion
//#region (ignored) ../../node_modules/.bun/get-random-values@1.2.2/node_modules/get-random-values
var require_get_random_values$1 = __commonJSMin((() => {}));
//#endregion
//#region ../../node_modules/.bun/get-random-values@1.2.2/node_modules/get-random-values/index.js
var require_get_random_values = __commonJSMin(((exports, module) => {
	var window = require_window();
	var nodeCrypto = require_get_random_values$1();
	function getRandomValues(buf) {
		if (window.crypto && window.crypto.getRandomValues) return window.crypto.getRandomValues(buf);
		if (typeof window.msCrypto === "object" && typeof window.msCrypto.getRandomValues === "function") return window.msCrypto.getRandomValues(buf);
		if (nodeCrypto.randomBytes) {
			if (!(buf instanceof Uint8Array)) throw new TypeError("expected Uint8Array");
			if (buf.length > 65536) {
				var e = new Error();
				e.code = 22;
				e.message = "Failed to execute 'getRandomValues' on 'Crypto': The ArrayBufferView's byte length (" + buf.length + ") exceeds the number of bytes of entropy available via this API (65536).";
				e.name = "QuotaExceededError";
				throw e;
			}
			var bytes = nodeCrypto.randomBytes(buf.length);
			buf.set(bytes);
			return buf;
		} else throw new Error("No secure random number generator available.");
	}
	module.exports = getRandomValues;
}));
//#endregion
//#region ../../node_modules/.bun/base64-js@1.5.1/node_modules/base64-js/index.js
var require_base64_js = __commonJSMin(((exports) => {
	exports.byteLength = byteLength;
	exports.toByteArray = toByteArray;
	exports.fromByteArray = fromByteArray;
	var lookup = [];
	var revLookup = [];
	var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
	var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	for (var i = 0, len = code.length; i < len; ++i) {
		lookup[i] = code[i];
		revLookup[code.charCodeAt(i)] = i;
	}
	revLookup["-".charCodeAt(0)] = 62;
	revLookup["_".charCodeAt(0)] = 63;
	function getLens(b64) {
		var len = b64.length;
		if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
		var validLen = b64.indexOf("=");
		if (validLen === -1) validLen = len;
		var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
		return [validLen, placeHoldersLen];
	}
	function byteLength(b64) {
		var lens = getLens(b64);
		var validLen = lens[0];
		var placeHoldersLen = lens[1];
		return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
	}
	function _byteLength(b64, validLen, placeHoldersLen) {
		return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
	}
	function toByteArray(b64) {
		var tmp;
		var lens = getLens(b64);
		var validLen = lens[0];
		var placeHoldersLen = lens[1];
		var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
		var curByte = 0;
		var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
		var i;
		for (i = 0; i < len; i += 4) {
			tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
			arr[curByte++] = tmp >> 16 & 255;
			arr[curByte++] = tmp >> 8 & 255;
			arr[curByte++] = tmp & 255;
		}
		if (placeHoldersLen === 2) {
			tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
			arr[curByte++] = tmp & 255;
		}
		if (placeHoldersLen === 1) {
			tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
			arr[curByte++] = tmp >> 8 & 255;
			arr[curByte++] = tmp & 255;
		}
		return arr;
	}
	function tripletToBase64(num) {
		return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
	}
	function encodeChunk(uint8, start, end) {
		var tmp;
		var output = [];
		for (var i = start; i < end; i += 3) {
			tmp = (uint8[i] << 16 & 16711680) + (uint8[i + 1] << 8 & 65280) + (uint8[i + 2] & 255);
			output.push(tripletToBase64(tmp));
		}
		return output.join("");
	}
	function fromByteArray(uint8) {
		var tmp;
		var len = uint8.length;
		var extraBytes = len % 3;
		var parts = [];
		var maxChunkLength = 16383;
		for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
		if (extraBytes === 1) {
			tmp = uint8[len - 1];
			parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "==");
		} else if (extraBytes === 2) {
			tmp = (uint8[len - 2] << 8) + uint8[len - 1];
			parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "=");
		}
		return parts.join("");
	}
}));
//#endregion
//#region ../../node_modules/.bun/ieee754@1.2.1/node_modules/ieee754/index.js
var require_ieee754 = __commonJSMin(((exports) => {
	exports.read = function(buffer, offset, isLE, mLen, nBytes) {
		var e, m;
		var eLen = nBytes * 8 - mLen - 1;
		var eMax = (1 << eLen) - 1;
		var eBias = eMax >> 1;
		var nBits = -7;
		var i = isLE ? nBytes - 1 : 0;
		var d = isLE ? -1 : 1;
		var s = buffer[offset + i];
		i += d;
		e = s & (1 << -nBits) - 1;
		s >>= -nBits;
		nBits += eLen;
		for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
		m = e & (1 << -nBits) - 1;
		e >>= -nBits;
		nBits += mLen;
		for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
		if (e === 0) e = 1 - eBias;
		else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
		else {
			m = m + Math.pow(2, mLen);
			e = e - eBias;
		}
		return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
	};
	exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
		var e, m, c;
		var eLen = nBytes * 8 - mLen - 1;
		var eMax = (1 << eLen) - 1;
		var eBias = eMax >> 1;
		var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
		var i = isLE ? 0 : nBytes - 1;
		var d = isLE ? 1 : -1;
		var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
		value = Math.abs(value);
		if (isNaN(value) || value === Infinity) {
			m = isNaN(value) ? 1 : 0;
			e = eMax;
		} else {
			e = Math.floor(Math.log(value) / Math.LN2);
			if (value * (c = Math.pow(2, -e)) < 1) {
				e--;
				c *= 2;
			}
			if (e + eBias >= 1) value += rt / c;
			else value += rt * Math.pow(2, 1 - eBias);
			if (value * c >= 2) {
				e++;
				c /= 2;
			}
			if (e + eBias >= eMax) {
				m = 0;
				e = eMax;
			} else if (e + eBias >= 1) {
				m = (value * c - 1) * Math.pow(2, mLen);
				e = e + eBias;
			} else {
				m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
				e = 0;
			}
		}
		for (; mLen >= 8; buffer[offset + i] = m & 255, i += d, m /= 256, mLen -= 8);
		e = e << mLen | m;
		eLen += mLen;
		for (; eLen > 0; buffer[offset + i] = e & 255, i += d, e /= 256, eLen -= 8);
		buffer[offset + i - d] |= s * 128;
	};
}));
//#endregion
//#region ../../node_modules/.bun/buffer@6.0.3/node_modules/buffer/index.js
var require_buffer = __commonJSMin(((exports) => {
	const base64 = require_base64_js();
	const ieee754 = require_ieee754();
	const customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
	exports.Buffer = Buffer;
	exports.SlowBuffer = SlowBuffer;
	exports.INSPECT_MAX_BYTES = 50;
	const K_MAX_LENGTH = 2147483647;
	exports.kMaxLength = K_MAX_LENGTH;
	Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
	if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
	function typedArraySupport() {
		try {
			const arr = new Uint8Array(1);
			const proto = { foo: function() {
				return 42;
			} };
			Object.setPrototypeOf(proto, Uint8Array.prototype);
			Object.setPrototypeOf(arr, proto);
			return arr.foo() === 42;
		} catch (e) {
			return false;
		}
	}
	Object.defineProperty(Buffer.prototype, "parent", {
		enumerable: true,
		get: function() {
			if (!Buffer.isBuffer(this)) return void 0;
			return this.buffer;
		}
	});
	Object.defineProperty(Buffer.prototype, "offset", {
		enumerable: true,
		get: function() {
			if (!Buffer.isBuffer(this)) return void 0;
			return this.byteOffset;
		}
	});
	function createBuffer(length) {
		if (length > K_MAX_LENGTH) throw new RangeError("The value \"" + length + "\" is invalid for option \"size\"");
		const buf = new Uint8Array(length);
		Object.setPrototypeOf(buf, Buffer.prototype);
		return buf;
	}
	function Buffer(arg, encodingOrOffset, length) {
		if (typeof arg === "number") {
			if (typeof encodingOrOffset === "string") throw new TypeError("The \"string\" argument must be of type string. Received type number");
			return allocUnsafe(arg);
		}
		return from(arg, encodingOrOffset, length);
	}
	Buffer.poolSize = 8192;
	function from(value, encodingOrOffset, length) {
		if (typeof value === "string") return fromString(value, encodingOrOffset);
		if (ArrayBuffer.isView(value)) return fromArrayView(value);
		if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
		if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
		if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
		if (typeof value === "number") throw new TypeError("The \"value\" argument must not be of type number. Received type number");
		const valueOf = value.valueOf && value.valueOf();
		if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
		const b = fromObject(value);
		if (b) return b;
		if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
		throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
	}
	Buffer.from = function(value, encodingOrOffset, length) {
		return from(value, encodingOrOffset, length);
	};
	Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
	Object.setPrototypeOf(Buffer, Uint8Array);
	function assertSize(size) {
		if (typeof size !== "number") throw new TypeError("\"size\" argument must be of type number");
		else if (size < 0) throw new RangeError("The value \"" + size + "\" is invalid for option \"size\"");
	}
	function alloc(size, fill, encoding) {
		assertSize(size);
		if (size <= 0) return createBuffer(size);
		if (fill !== void 0) return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
		return createBuffer(size);
	}
	Buffer.alloc = function(size, fill, encoding) {
		return alloc(size, fill, encoding);
	};
	function allocUnsafe(size) {
		assertSize(size);
		return createBuffer(size < 0 ? 0 : checked(size) | 0);
	}
	Buffer.allocUnsafe = function(size) {
		return allocUnsafe(size);
	};
	Buffer.allocUnsafeSlow = function(size) {
		return allocUnsafe(size);
	};
	function fromString(string, encoding) {
		if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
		if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
		const length = byteLength(string, encoding) | 0;
		let buf = createBuffer(length);
		const actual = buf.write(string, encoding);
		if (actual !== length) buf = buf.slice(0, actual);
		return buf;
	}
	function fromArrayLike(array) {
		const length = array.length < 0 ? 0 : checked(array.length) | 0;
		const buf = createBuffer(length);
		for (let i = 0; i < length; i += 1) buf[i] = array[i] & 255;
		return buf;
	}
	function fromArrayView(arrayView) {
		if (isInstance(arrayView, Uint8Array)) {
			const copy = new Uint8Array(arrayView);
			return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
		}
		return fromArrayLike(arrayView);
	}
	function fromArrayBuffer(array, byteOffset, length) {
		if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("\"offset\" is outside of buffer bounds");
		if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("\"length\" is outside of buffer bounds");
		let buf;
		if (byteOffset === void 0 && length === void 0) buf = new Uint8Array(array);
		else if (length === void 0) buf = new Uint8Array(array, byteOffset);
		else buf = new Uint8Array(array, byteOffset, length);
		Object.setPrototypeOf(buf, Buffer.prototype);
		return buf;
	}
	function fromObject(obj) {
		if (Buffer.isBuffer(obj)) {
			const len = checked(obj.length) | 0;
			const buf = createBuffer(len);
			if (buf.length === 0) return buf;
			obj.copy(buf, 0, 0, len);
			return buf;
		}
		if (obj.length !== void 0) {
			if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
			return fromArrayLike(obj);
		}
		if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
	}
	function checked(length) {
		if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
		return length | 0;
	}
	function SlowBuffer(length) {
		if (+length != length) length = 0;
		return Buffer.alloc(+length);
	}
	Buffer.isBuffer = function isBuffer(b) {
		return b != null && b._isBuffer === true && b !== Buffer.prototype;
	};
	Buffer.compare = function compare(a, b) {
		if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
		if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
		if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError("The \"buf1\", \"buf2\" arguments must be one of type Buffer or Uint8Array");
		if (a === b) return 0;
		let x = a.length;
		let y = b.length;
		for (let i = 0, len = Math.min(x, y); i < len; ++i) if (a[i] !== b[i]) {
			x = a[i];
			y = b[i];
			break;
		}
		if (x < y) return -1;
		if (y < x) return 1;
		return 0;
	};
	Buffer.isEncoding = function isEncoding(encoding) {
		switch (String(encoding).toLowerCase()) {
			case "hex":
			case "utf8":
			case "utf-8":
			case "ascii":
			case "latin1":
			case "binary":
			case "base64":
			case "ucs2":
			case "ucs-2":
			case "utf16le":
			case "utf-16le": return true;
			default: return false;
		}
	};
	Buffer.concat = function concat(list, length) {
		if (!Array.isArray(list)) throw new TypeError("\"list\" argument must be an Array of Buffers");
		if (list.length === 0) return Buffer.alloc(0);
		let i;
		if (length === void 0) {
			length = 0;
			for (i = 0; i < list.length; ++i) length += list[i].length;
		}
		const buffer = Buffer.allocUnsafe(length);
		let pos = 0;
		for (i = 0; i < list.length; ++i) {
			let buf = list[i];
			if (isInstance(buf, Uint8Array)) {
				if (pos + buf.length > buffer.length) {
					if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
					buf.copy(buffer, pos);
				} else Uint8Array.prototype.set.call(buffer, buf, pos);
			} else if (!Buffer.isBuffer(buf)) throw new TypeError("\"list\" argument must be an Array of Buffers");
			else buf.copy(buffer, pos);
			pos += buf.length;
		}
		return buffer;
	};
	function byteLength(string, encoding) {
		if (Buffer.isBuffer(string)) return string.length;
		if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
		if (typeof string !== "string") throw new TypeError("The \"string\" argument must be one of type string, Buffer, or ArrayBuffer. Received type " + typeof string);
		const len = string.length;
		const mustMatch = arguments.length > 2 && arguments[2] === true;
		if (!mustMatch && len === 0) return 0;
		let loweredCase = false;
		for (;;) switch (encoding) {
			case "ascii":
			case "latin1":
			case "binary": return len;
			case "utf8":
			case "utf-8": return utf8ToBytes(string).length;
			case "ucs2":
			case "ucs-2":
			case "utf16le":
			case "utf-16le": return len * 2;
			case "hex": return len >>> 1;
			case "base64": return base64ToBytes(string).length;
			default:
				if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length;
				encoding = ("" + encoding).toLowerCase();
				loweredCase = true;
		}
	}
	Buffer.byteLength = byteLength;
	function slowToString(encoding, start, end) {
		let loweredCase = false;
		if (start === void 0 || start < 0) start = 0;
		if (start > this.length) return "";
		if (end === void 0 || end > this.length) end = this.length;
		if (end <= 0) return "";
		end >>>= 0;
		start >>>= 0;
		if (end <= start) return "";
		if (!encoding) encoding = "utf8";
		while (true) switch (encoding) {
			case "hex": return hexSlice(this, start, end);
			case "utf8":
			case "utf-8": return utf8Slice(this, start, end);
			case "ascii": return asciiSlice(this, start, end);
			case "latin1":
			case "binary": return latin1Slice(this, start, end);
			case "base64": return base64Slice(this, start, end);
			case "ucs2":
			case "ucs-2":
			case "utf16le":
			case "utf-16le": return utf16leSlice(this, start, end);
			default:
				if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
				encoding = (encoding + "").toLowerCase();
				loweredCase = true;
		}
	}
	Buffer.prototype._isBuffer = true;
	function swap(b, n, m) {
		const i = b[n];
		b[n] = b[m];
		b[m] = i;
	}
	Buffer.prototype.swap16 = function swap16() {
		const len = this.length;
		if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
		for (let i = 0; i < len; i += 2) swap(this, i, i + 1);
		return this;
	};
	Buffer.prototype.swap32 = function swap32() {
		const len = this.length;
		if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
		for (let i = 0; i < len; i += 4) {
			swap(this, i, i + 3);
			swap(this, i + 1, i + 2);
		}
		return this;
	};
	Buffer.prototype.swap64 = function swap64() {
		const len = this.length;
		if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
		for (let i = 0; i < len; i += 8) {
			swap(this, i, i + 7);
			swap(this, i + 1, i + 6);
			swap(this, i + 2, i + 5);
			swap(this, i + 3, i + 4);
		}
		return this;
	};
	Buffer.prototype.toString = function toString() {
		const length = this.length;
		if (length === 0) return "";
		if (arguments.length === 0) return utf8Slice(this, 0, length);
		return slowToString.apply(this, arguments);
	};
	Buffer.prototype.toLocaleString = Buffer.prototype.toString;
	Buffer.prototype.equals = function equals(b) {
		if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
		if (this === b) return true;
		return Buffer.compare(this, b) === 0;
	};
	Buffer.prototype.inspect = function inspect() {
		let str = "";
		const max = exports.INSPECT_MAX_BYTES;
		str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
		if (this.length > max) str += " ... ";
		return "<Buffer " + str + ">";
	};
	if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
	Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
		if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
		if (!Buffer.isBuffer(target)) throw new TypeError("The \"target\" argument must be one of type Buffer or Uint8Array. Received type " + typeof target);
		if (start === void 0) start = 0;
		if (end === void 0) end = target ? target.length : 0;
		if (thisStart === void 0) thisStart = 0;
		if (thisEnd === void 0) thisEnd = this.length;
		if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
		if (thisStart >= thisEnd && start >= end) return 0;
		if (thisStart >= thisEnd) return -1;
		if (start >= end) return 1;
		start >>>= 0;
		end >>>= 0;
		thisStart >>>= 0;
		thisEnd >>>= 0;
		if (this === target) return 0;
		let x = thisEnd - thisStart;
		let y = end - start;
		const len = Math.min(x, y);
		const thisCopy = this.slice(thisStart, thisEnd);
		const targetCopy = target.slice(start, end);
		for (let i = 0; i < len; ++i) if (thisCopy[i] !== targetCopy[i]) {
			x = thisCopy[i];
			y = targetCopy[i];
			break;
		}
		if (x < y) return -1;
		if (y < x) return 1;
		return 0;
	};
	function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
		if (buffer.length === 0) return -1;
		if (typeof byteOffset === "string") {
			encoding = byteOffset;
			byteOffset = 0;
		} else if (byteOffset > 2147483647) byteOffset = 2147483647;
		else if (byteOffset < -2147483648) byteOffset = -2147483648;
		byteOffset = +byteOffset;
		if (numberIsNaN(byteOffset)) byteOffset = dir ? 0 : buffer.length - 1;
		if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
		if (byteOffset >= buffer.length) {
			if (dir) return -1;
			else byteOffset = buffer.length - 1;
		} else if (byteOffset < 0) {
			if (dir) byteOffset = 0;
			else return -1;
		}
		if (typeof val === "string") val = Buffer.from(val, encoding);
		if (Buffer.isBuffer(val)) {
			if (val.length === 0) return -1;
			return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
		} else if (typeof val === "number") {
			val = val & 255;
			if (typeof Uint8Array.prototype.indexOf === "function") {
				if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
				else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
			}
			return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
		}
		throw new TypeError("val must be string, number or Buffer");
	}
	function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
		let indexSize = 1;
		let arrLength = arr.length;
		let valLength = val.length;
		if (encoding !== void 0) {
			encoding = String(encoding).toLowerCase();
			if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
				if (arr.length < 2 || val.length < 2) return -1;
				indexSize = 2;
				arrLength /= 2;
				valLength /= 2;
				byteOffset /= 2;
			}
		}
		function read(buf, i) {
			if (indexSize === 1) return buf[i];
			else return buf.readUInt16BE(i * indexSize);
		}
		let i;
		if (dir) {
			let foundIndex = -1;
			for (i = byteOffset; i < arrLength; i++) if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
				if (foundIndex === -1) foundIndex = i;
				if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
			} else {
				if (foundIndex !== -1) i -= i - foundIndex;
				foundIndex = -1;
			}
		} else {
			if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
			for (i = byteOffset; i >= 0; i--) {
				let found = true;
				for (let j = 0; j < valLength; j++) if (read(arr, i + j) !== read(val, j)) {
					found = false;
					break;
				}
				if (found) return i;
			}
		}
		return -1;
	}
	Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
		return this.indexOf(val, byteOffset, encoding) !== -1;
	};
	Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
		return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
	};
	Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
		return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
	};
	function hexWrite(buf, string, offset, length) {
		offset = Number(offset) || 0;
		const remaining = buf.length - offset;
		if (!length) length = remaining;
		else {
			length = Number(length);
			if (length > remaining) length = remaining;
		}
		const strLen = string.length;
		if (length > strLen / 2) length = strLen / 2;
		let i;
		for (i = 0; i < length; ++i) {
			const parsed = parseInt(string.substr(i * 2, 2), 16);
			if (numberIsNaN(parsed)) return i;
			buf[offset + i] = parsed;
		}
		return i;
	}
	function utf8Write(buf, string, offset, length) {
		return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
	}
	function asciiWrite(buf, string, offset, length) {
		return blitBuffer(asciiToBytes(string), buf, offset, length);
	}
	function base64Write(buf, string, offset, length) {
		return blitBuffer(base64ToBytes(string), buf, offset, length);
	}
	function ucs2Write(buf, string, offset, length) {
		return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
	}
	Buffer.prototype.write = function write(string, offset, length, encoding) {
		if (offset === void 0) {
			encoding = "utf8";
			length = this.length;
			offset = 0;
		} else if (length === void 0 && typeof offset === "string") {
			encoding = offset;
			length = this.length;
			offset = 0;
		} else if (isFinite(offset)) {
			offset = offset >>> 0;
			if (isFinite(length)) {
				length = length >>> 0;
				if (encoding === void 0) encoding = "utf8";
			} else {
				encoding = length;
				length = void 0;
			}
		} else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
		const remaining = this.length - offset;
		if (length === void 0 || length > remaining) length = remaining;
		if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
		if (!encoding) encoding = "utf8";
		let loweredCase = false;
		for (;;) switch (encoding) {
			case "hex": return hexWrite(this, string, offset, length);
			case "utf8":
			case "utf-8": return utf8Write(this, string, offset, length);
			case "ascii":
			case "latin1":
			case "binary": return asciiWrite(this, string, offset, length);
			case "base64": return base64Write(this, string, offset, length);
			case "ucs2":
			case "ucs-2":
			case "utf16le":
			case "utf-16le": return ucs2Write(this, string, offset, length);
			default:
				if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
				encoding = ("" + encoding).toLowerCase();
				loweredCase = true;
		}
	};
	Buffer.prototype.toJSON = function toJSON() {
		return {
			type: "Buffer",
			data: Array.prototype.slice.call(this._arr || this, 0)
		};
	};
	function base64Slice(buf, start, end) {
		if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
		else return base64.fromByteArray(buf.slice(start, end));
	}
	function utf8Slice(buf, start, end) {
		end = Math.min(buf.length, end);
		const res = [];
		let i = start;
		while (i < end) {
			const firstByte = buf[i];
			let codePoint = null;
			let bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
			if (i + bytesPerSequence <= end) {
				let secondByte, thirdByte, fourthByte, tempCodePoint;
				switch (bytesPerSequence) {
					case 1:
						if (firstByte < 128) codePoint = firstByte;
						break;
					case 2:
						secondByte = buf[i + 1];
						if ((secondByte & 192) === 128) {
							tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
							if (tempCodePoint > 127) codePoint = tempCodePoint;
						}
						break;
					case 3:
						secondByte = buf[i + 1];
						thirdByte = buf[i + 2];
						if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
							tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
							if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) codePoint = tempCodePoint;
						}
						break;
					case 4:
						secondByte = buf[i + 1];
						thirdByte = buf[i + 2];
						fourthByte = buf[i + 3];
						if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
							tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
							if (tempCodePoint > 65535 && tempCodePoint < 1114112) codePoint = tempCodePoint;
						}
				}
			}
			if (codePoint === null) {
				codePoint = 65533;
				bytesPerSequence = 1;
			} else if (codePoint > 65535) {
				codePoint -= 65536;
				res.push(codePoint >>> 10 & 1023 | 55296);
				codePoint = 56320 | codePoint & 1023;
			}
			res.push(codePoint);
			i += bytesPerSequence;
		}
		return decodeCodePointsArray(res);
	}
	const MAX_ARGUMENTS_LENGTH = 4096;
	function decodeCodePointsArray(codePoints) {
		const len = codePoints.length;
		if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints);
		let res = "";
		let i = 0;
		while (i < len) res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
		return res;
	}
	function asciiSlice(buf, start, end) {
		let ret = "";
		end = Math.min(buf.length, end);
		for (let i = start; i < end; ++i) ret += String.fromCharCode(buf[i] & 127);
		return ret;
	}
	function latin1Slice(buf, start, end) {
		let ret = "";
		end = Math.min(buf.length, end);
		for (let i = start; i < end; ++i) ret += String.fromCharCode(buf[i]);
		return ret;
	}
	function hexSlice(buf, start, end) {
		const len = buf.length;
		if (!start || start < 0) start = 0;
		if (!end || end < 0 || end > len) end = len;
		let out = "";
		for (let i = start; i < end; ++i) out += hexSliceLookupTable[buf[i]];
		return out;
	}
	function utf16leSlice(buf, start, end) {
		const bytes = buf.slice(start, end);
		let res = "";
		for (let i = 0; i < bytes.length - 1; i += 2) res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
		return res;
	}
	Buffer.prototype.slice = function slice(start, end) {
		const len = this.length;
		start = ~~start;
		end = end === void 0 ? len : ~~end;
		if (start < 0) {
			start += len;
			if (start < 0) start = 0;
		} else if (start > len) start = len;
		if (end < 0) {
			end += len;
			if (end < 0) end = 0;
		} else if (end > len) end = len;
		if (end < start) end = start;
		const newBuf = this.subarray(start, end);
		Object.setPrototypeOf(newBuf, Buffer.prototype);
		return newBuf;
	};
	function checkOffset(offset, ext, length) {
		if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
		if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
	}
	Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
		offset = offset >>> 0;
		byteLength = byteLength >>> 0;
		if (!noAssert) checkOffset(offset, byteLength, this.length);
		let val = this[offset];
		let mul = 1;
		let i = 0;
		while (++i < byteLength && (mul *= 256)) val += this[offset + i] * mul;
		return val;
	};
	Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
		offset = offset >>> 0;
		byteLength = byteLength >>> 0;
		if (!noAssert) checkOffset(offset, byteLength, this.length);
		let val = this[offset + --byteLength];
		let mul = 1;
		while (byteLength > 0 && (mul *= 256)) val += this[offset + --byteLength] * mul;
		return val;
	};
	Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 1, this.length);
		return this[offset];
	};
	Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 2, this.length);
		return this[offset] | this[offset + 1] << 8;
	};
	Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 2, this.length);
		return this[offset] << 8 | this[offset + 1];
	};
	Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 4, this.length);
		return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
	};
	Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 4, this.length);
		return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
	};
	Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
		offset = offset >>> 0;
		validateNumber(offset, "offset");
		const first = this[offset];
		const last = this[offset + 7];
		if (first === void 0 || last === void 0) boundsError(offset, this.length - 8);
		const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
		const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
		return BigInt(lo) + (BigInt(hi) << BigInt(32));
	});
	Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
		offset = offset >>> 0;
		validateNumber(offset, "offset");
		const first = this[offset];
		const last = this[offset + 7];
		if (first === void 0 || last === void 0) boundsError(offset, this.length - 8);
		const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
		const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
		return (BigInt(hi) << BigInt(32)) + BigInt(lo);
	});
	Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
		offset = offset >>> 0;
		byteLength = byteLength >>> 0;
		if (!noAssert) checkOffset(offset, byteLength, this.length);
		let val = this[offset];
		let mul = 1;
		let i = 0;
		while (++i < byteLength && (mul *= 256)) val += this[offset + i] * mul;
		mul *= 128;
		if (val >= mul) val -= Math.pow(2, 8 * byteLength);
		return val;
	};
	Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
		offset = offset >>> 0;
		byteLength = byteLength >>> 0;
		if (!noAssert) checkOffset(offset, byteLength, this.length);
		let i = byteLength;
		let mul = 1;
		let val = this[offset + --i];
		while (i > 0 && (mul *= 256)) val += this[offset + --i] * mul;
		mul *= 128;
		if (val >= mul) val -= Math.pow(2, 8 * byteLength);
		return val;
	};
	Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 1, this.length);
		if (!(this[offset] & 128)) return this[offset];
		return (255 - this[offset] + 1) * -1;
	};
	Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 2, this.length);
		const val = this[offset] | this[offset + 1] << 8;
		return val & 32768 ? val | 4294901760 : val;
	};
	Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 2, this.length);
		const val = this[offset + 1] | this[offset] << 8;
		return val & 32768 ? val | 4294901760 : val;
	};
	Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 4, this.length);
		return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
	};
	Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 4, this.length);
		return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
	};
	Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
		offset = offset >>> 0;
		validateNumber(offset, "offset");
		const first = this[offset];
		const last = this[offset + 7];
		if (first === void 0 || last === void 0) boundsError(offset, this.length - 8);
		const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24);
		return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
	});
	Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
		offset = offset >>> 0;
		validateNumber(offset, "offset");
		const first = this[offset];
		const last = this[offset + 7];
		if (first === void 0 || last === void 0) boundsError(offset, this.length - 8);
		const val = (first << 24) + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
		return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
	});
	Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 4, this.length);
		return ieee754.read(this, offset, true, 23, 4);
	};
	Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 4, this.length);
		return ieee754.read(this, offset, false, 23, 4);
	};
	Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 8, this.length);
		return ieee754.read(this, offset, true, 52, 8);
	};
	Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 8, this.length);
		return ieee754.read(this, offset, false, 52, 8);
	};
	function checkInt(buf, value, offset, ext, max, min) {
		if (!Buffer.isBuffer(buf)) throw new TypeError("\"buffer\" argument must be a Buffer instance");
		if (value > max || value < min) throw new RangeError("\"value\" argument is out of bounds");
		if (offset + ext > buf.length) throw new RangeError("Index out of range");
	}
	Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
		value = +value;
		offset = offset >>> 0;
		byteLength = byteLength >>> 0;
		if (!noAssert) {
			const maxBytes = Math.pow(2, 8 * byteLength) - 1;
			checkInt(this, value, offset, byteLength, maxBytes, 0);
		}
		let mul = 1;
		let i = 0;
		this[offset] = value & 255;
		while (++i < byteLength && (mul *= 256)) this[offset + i] = value / mul & 255;
		return offset + byteLength;
	};
	Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
		value = +value;
		offset = offset >>> 0;
		byteLength = byteLength >>> 0;
		if (!noAssert) {
			const maxBytes = Math.pow(2, 8 * byteLength) - 1;
			checkInt(this, value, offset, byteLength, maxBytes, 0);
		}
		let i = byteLength - 1;
		let mul = 1;
		this[offset + i] = value & 255;
		while (--i >= 0 && (mul *= 256)) this[offset + i] = value / mul & 255;
		return offset + byteLength;
	};
	Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkInt(this, value, offset, 1, 255, 0);
		this[offset] = value & 255;
		return offset + 1;
	};
	Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkInt(this, value, offset, 2, 65535, 0);
		this[offset] = value & 255;
		this[offset + 1] = value >>> 8;
		return offset + 2;
	};
	Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkInt(this, value, offset, 2, 65535, 0);
		this[offset] = value >>> 8;
		this[offset + 1] = value & 255;
		return offset + 2;
	};
	Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkInt(this, value, offset, 4, 4294967295, 0);
		this[offset + 3] = value >>> 24;
		this[offset + 2] = value >>> 16;
		this[offset + 1] = value >>> 8;
		this[offset] = value & 255;
		return offset + 4;
	};
	Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkInt(this, value, offset, 4, 4294967295, 0);
		this[offset] = value >>> 24;
		this[offset + 1] = value >>> 16;
		this[offset + 2] = value >>> 8;
		this[offset + 3] = value & 255;
		return offset + 4;
	};
	function wrtBigUInt64LE(buf, value, offset, min, max) {
		checkIntBI(value, min, max, buf, offset, 7);
		let lo = Number(value & BigInt(4294967295));
		buf[offset++] = lo;
		lo = lo >> 8;
		buf[offset++] = lo;
		lo = lo >> 8;
		buf[offset++] = lo;
		lo = lo >> 8;
		buf[offset++] = lo;
		let hi = Number(value >> BigInt(32) & BigInt(4294967295));
		buf[offset++] = hi;
		hi = hi >> 8;
		buf[offset++] = hi;
		hi = hi >> 8;
		buf[offset++] = hi;
		hi = hi >> 8;
		buf[offset++] = hi;
		return offset;
	}
	function wrtBigUInt64BE(buf, value, offset, min, max) {
		checkIntBI(value, min, max, buf, offset, 7);
		let lo = Number(value & BigInt(4294967295));
		buf[offset + 7] = lo;
		lo = lo >> 8;
		buf[offset + 6] = lo;
		lo = lo >> 8;
		buf[offset + 5] = lo;
		lo = lo >> 8;
		buf[offset + 4] = lo;
		let hi = Number(value >> BigInt(32) & BigInt(4294967295));
		buf[offset + 3] = hi;
		hi = hi >> 8;
		buf[offset + 2] = hi;
		hi = hi >> 8;
		buf[offset + 1] = hi;
		hi = hi >> 8;
		buf[offset] = hi;
		return offset + 8;
	}
	Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
		return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
	});
	Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
		return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
	});
	Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) {
			const limit = Math.pow(2, 8 * byteLength - 1);
			checkInt(this, value, offset, byteLength, limit - 1, -limit);
		}
		let i = 0;
		let mul = 1;
		let sub = 0;
		this[offset] = value & 255;
		while (++i < byteLength && (mul *= 256)) {
			if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
			this[offset + i] = (value / mul >> 0) - sub & 255;
		}
		return offset + byteLength;
	};
	Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) {
			const limit = Math.pow(2, 8 * byteLength - 1);
			checkInt(this, value, offset, byteLength, limit - 1, -limit);
		}
		let i = byteLength - 1;
		let mul = 1;
		let sub = 0;
		this[offset + i] = value & 255;
		while (--i >= 0 && (mul *= 256)) {
			if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
			this[offset + i] = (value / mul >> 0) - sub & 255;
		}
		return offset + byteLength;
	};
	Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkInt(this, value, offset, 1, 127, -128);
		if (value < 0) value = 255 + value + 1;
		this[offset] = value & 255;
		return offset + 1;
	};
	Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkInt(this, value, offset, 2, 32767, -32768);
		this[offset] = value & 255;
		this[offset + 1] = value >>> 8;
		return offset + 2;
	};
	Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkInt(this, value, offset, 2, 32767, -32768);
		this[offset] = value >>> 8;
		this[offset + 1] = value & 255;
		return offset + 2;
	};
	Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkInt(this, value, offset, 4, 2147483647, -2147483648);
		this[offset] = value & 255;
		this[offset + 1] = value >>> 8;
		this[offset + 2] = value >>> 16;
		this[offset + 3] = value >>> 24;
		return offset + 4;
	};
	Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkInt(this, value, offset, 4, 2147483647, -2147483648);
		if (value < 0) value = 4294967295 + value + 1;
		this[offset] = value >>> 24;
		this[offset + 1] = value >>> 16;
		this[offset + 2] = value >>> 8;
		this[offset + 3] = value & 255;
		return offset + 4;
	};
	Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
		return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
	});
	Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
		return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
	});
	function checkIEEE754(buf, value, offset, ext, max, min) {
		if (offset + ext > buf.length) throw new RangeError("Index out of range");
		if (offset < 0) throw new RangeError("Index out of range");
	}
	function writeFloat(buf, value, offset, littleEndian, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkIEEE754(buf, value, offset, 4, 34028234663852886e22, -34028234663852886e22);
		ieee754.write(buf, value, offset, littleEndian, 23, 4);
		return offset + 4;
	}
	Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
		return writeFloat(this, value, offset, true, noAssert);
	};
	Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
		return writeFloat(this, value, offset, false, noAssert);
	};
	function writeDouble(buf, value, offset, littleEndian, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkIEEE754(buf, value, offset, 8, 17976931348623157e292, -17976931348623157e292);
		ieee754.write(buf, value, offset, littleEndian, 52, 8);
		return offset + 8;
	}
	Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
		return writeDouble(this, value, offset, true, noAssert);
	};
	Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
		return writeDouble(this, value, offset, false, noAssert);
	};
	Buffer.prototype.copy = function copy(target, targetStart, start, end) {
		if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
		if (!start) start = 0;
		if (!end && end !== 0) end = this.length;
		if (targetStart >= target.length) targetStart = target.length;
		if (!targetStart) targetStart = 0;
		if (end > 0 && end < start) end = start;
		if (end === start) return 0;
		if (target.length === 0 || this.length === 0) return 0;
		if (targetStart < 0) throw new RangeError("targetStart out of bounds");
		if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
		if (end < 0) throw new RangeError("sourceEnd out of bounds");
		if (end > this.length) end = this.length;
		if (target.length - targetStart < end - start) end = target.length - targetStart + start;
		const len = end - start;
		if (this === target && typeof Uint8Array.prototype.copyWithin === "function") this.copyWithin(targetStart, start, end);
		else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
		return len;
	};
	Buffer.prototype.fill = function fill(val, start, end, encoding) {
		if (typeof val === "string") {
			if (typeof start === "string") {
				encoding = start;
				start = 0;
				end = this.length;
			} else if (typeof end === "string") {
				encoding = end;
				end = this.length;
			}
			if (encoding !== void 0 && typeof encoding !== "string") throw new TypeError("encoding must be a string");
			if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
			if (val.length === 1) {
				const code = val.charCodeAt(0);
				if (encoding === "utf8" && code < 128 || encoding === "latin1") val = code;
			}
		} else if (typeof val === "number") val = val & 255;
		else if (typeof val === "boolean") val = Number(val);
		if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
		if (end <= start) return this;
		start = start >>> 0;
		end = end === void 0 ? this.length : end >>> 0;
		if (!val) val = 0;
		let i;
		if (typeof val === "number") for (i = start; i < end; ++i) this[i] = val;
		else {
			const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
			const len = bytes.length;
			if (len === 0) throw new TypeError("The value \"" + val + "\" is invalid for argument \"value\"");
			for (i = 0; i < end - start; ++i) this[i + start] = bytes[i % len];
		}
		return this;
	};
	const errors = {};
	function E(sym, getMessage, Base) {
		errors[sym] = class NodeError extends Base {
			constructor() {
				super();
				Object.defineProperty(this, "message", {
					value: getMessage.apply(this, arguments),
					writable: true,
					configurable: true
				});
				this.name = `${this.name} [${sym}]`;
				this.stack;
				delete this.name;
			}
			get code() {
				return sym;
			}
			set code(value) {
				Object.defineProperty(this, "code", {
					configurable: true,
					enumerable: true,
					value,
					writable: true
				});
			}
			toString() {
				return `${this.name} [${sym}]: ${this.message}`;
			}
		};
	}
	E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
		if (name) return `${name} is outside of buffer bounds`;
		return "Attempt to access memory outside buffer bounds";
	}, RangeError);
	E("ERR_INVALID_ARG_TYPE", function(name, actual) {
		return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
	}, TypeError);
	E("ERR_OUT_OF_RANGE", function(str, range, input) {
		let msg = `The value of "${str}" is out of range.`;
		let received = input;
		if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
		else if (typeof input === "bigint") {
			received = String(input);
			if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
			received += "n";
		}
		msg += ` It must be ${range}. Received ${received}`;
		return msg;
	}, RangeError);
	function addNumericalSeparator(val) {
		let res = "";
		let i = val.length;
		const start = val[0] === "-" ? 1 : 0;
		for (; i >= start + 4; i -= 3) res = `_${val.slice(i - 3, i)}${res}`;
		return `${val.slice(0, i)}${res}`;
	}
	function checkBounds(buf, offset, byteLength) {
		validateNumber(offset, "offset");
		if (buf[offset] === void 0 || buf[offset + byteLength] === void 0) boundsError(offset, buf.length - (byteLength + 1));
	}
	function checkIntBI(value, min, max, buf, offset, byteLength) {
		if (value > max || value < min) {
			const n = typeof min === "bigint" ? "n" : "";
			let range;
			if (byteLength > 3) {
				if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
				else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ${(byteLength + 1) * 8 - 1}${n}`;
			} else range = `>= ${min}${n} and <= ${max}${n}`;
			throw new errors.ERR_OUT_OF_RANGE("value", range, value);
		}
		checkBounds(buf, offset, byteLength);
	}
	function validateNumber(value, name) {
		if (typeof value !== "number") throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
	}
	function boundsError(value, length, type) {
		if (Math.floor(value) !== value) {
			validateNumber(value, type);
			throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
		}
		if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
		throw new errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
	}
	const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
	function base64clean(str) {
		str = str.split("=")[0];
		str = str.trim().replace(INVALID_BASE64_RE, "");
		if (str.length < 2) return "";
		while (str.length % 4 !== 0) str = str + "=";
		return str;
	}
	function utf8ToBytes(string, units) {
		units = units || Infinity;
		let codePoint;
		const length = string.length;
		let leadSurrogate = null;
		const bytes = [];
		for (let i = 0; i < length; ++i) {
			codePoint = string.charCodeAt(i);
			if (codePoint > 55295 && codePoint < 57344) {
				if (!leadSurrogate) {
					if (codePoint > 56319) {
						if ((units -= 3) > -1) bytes.push(239, 191, 189);
						continue;
					} else if (i + 1 === length) {
						if ((units -= 3) > -1) bytes.push(239, 191, 189);
						continue;
					}
					leadSurrogate = codePoint;
					continue;
				}
				if (codePoint < 56320) {
					if ((units -= 3) > -1) bytes.push(239, 191, 189);
					leadSurrogate = codePoint;
					continue;
				}
				codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
			} else if (leadSurrogate) {
				if ((units -= 3) > -1) bytes.push(239, 191, 189);
			}
			leadSurrogate = null;
			if (codePoint < 128) {
				if ((units -= 1) < 0) break;
				bytes.push(codePoint);
			} else if (codePoint < 2048) {
				if ((units -= 2) < 0) break;
				bytes.push(codePoint >> 6 | 192, codePoint & 63 | 128);
			} else if (codePoint < 65536) {
				if ((units -= 3) < 0) break;
				bytes.push(codePoint >> 12 | 224, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
			} else if (codePoint < 1114112) {
				if ((units -= 4) < 0) break;
				bytes.push(codePoint >> 18 | 240, codePoint >> 12 & 63 | 128, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
			} else throw new Error("Invalid code point");
		}
		return bytes;
	}
	function asciiToBytes(str) {
		const byteArray = [];
		for (let i = 0; i < str.length; ++i) byteArray.push(str.charCodeAt(i) & 255);
		return byteArray;
	}
	function utf16leToBytes(str, units) {
		let c, hi, lo;
		const byteArray = [];
		for (let i = 0; i < str.length; ++i) {
			if ((units -= 2) < 0) break;
			c = str.charCodeAt(i);
			hi = c >> 8;
			lo = c % 256;
			byteArray.push(lo);
			byteArray.push(hi);
		}
		return byteArray;
	}
	function base64ToBytes(str) {
		return base64.toByteArray(base64clean(str));
	}
	function blitBuffer(src, dst, offset, length) {
		let i;
		for (i = 0; i < length; ++i) {
			if (i + offset >= dst.length || i >= src.length) break;
			dst[i + offset] = src[i];
		}
		return i;
	}
	function isInstance(obj, type) {
		return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
	}
	function numberIsNaN(obj) {
		return obj !== obj;
	}
	const hexSliceLookupTable = (function() {
		const alphabet = "0123456789abcdef";
		const table = new Array(256);
		for (let i = 0; i < 16; ++i) {
			const i16 = i * 16;
			for (let j = 0; j < 16; ++j) table[i16 + j] = alphabet[i] + alphabet[j];
		}
		return table;
	})();
	function defineBigIntMethod(fn) {
		return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
	}
	function BufferBigIntNotDefined() {
		throw new Error("BigInt not supported");
	}
}));
//#endregion
//#region ../../node_modules/.bun/scatter-ts@0.1.9/node_modules/scatter-ts/scatter.js
var require_scatter = __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	var WebSocket = require_browser();
	var createHash = (init_create_hash(), __toCommonJS(create_hash_exports));
	var getRandomValues = require_get_random_values();
	var _ = require_buffer();
	function _interopDefaultLegacy(e) {
		return e && typeof e === "object" && "default" in e ? e : { "default": e };
	}
	var WebSocket__default = _interopDefaultLegacy(WebSocket);
	var createHash__default = _interopDefaultLegacy(createHash);
	var getRandomValues__default = _interopDefaultLegacy(getRandomValues);
	const Blockchains = {
		EOS: "eos",
		ETH: "eth",
		TRX: "trx"
	};
	Object.keys(Blockchains).map((key) => ({
		key,
		value: Blockchains[key]
	}));
	var Token = class Token {
		constructor(blockchain = Blockchains.EOS, contract = "", symbol = "", name = null, decimals = null) {
			this.blockchain = blockchain;
			this.contract = contract;
			this.symbol = symbol;
			this.name = name ? name : symbol;
			this.decimals = decimals;
		}
		static placeholder() {
			return new Token();
		}
		static fromJson(json) {
			return Object.assign(this.placeholder(), json);
		}
	};
	const BLOCKCHAIN_SUPPORT = "blockchain_support";
	const WALLET_SUPPORT = "wallet_support";
	var PluginTypes = Object.freeze({
		__proto__: null,
		BLOCKCHAIN_SUPPORT,
		WALLET_SUPPORT
	});
	var Plugin = class Plugin {
		constructor(_name = "", _type = "") {
			this.name = _name;
			this.type = _type;
		}
		static placeholder() {
			return new Plugin();
		}
		static fromJson(json) {
			return Object.assign(Plugin.placeholder(), json);
		}
		isSignatureProvider() {
			return this.type === BLOCKCHAIN_SUPPORT;
		}
		isValid() {
			return Object.keys(PluginTypes).map((x) => PluginTypes[x]).includes(this.type);
		}
	};
	const WALLET_METHODS = {
		disconnect: "disconnect",
		isConnected: "isConnected",
		isPaired: "isPaired",
		addEventHandler: "addEventHandler",
		removeEventHandler: "removeEventHandler",
		listen: "listen",
		getVersion: "getVersion",
		getIdentity: "getIdentity",
		getAllAccountsFor: "getAllAccountsFor",
		getIdentityFromPermissions: "getIdentityFromPermissions",
		forgetIdentity: "forgetIdentity",
		updateIdentity: "updateIdentity",
		authenticate: "authenticate",
		getArbitrarySignature: "getArbitrarySignature",
		getPublicKey: "getPublicKey",
		linkAccount: "linkAccount",
		hasAccountFor: "hasAccountFor",
		suggestNetwork: "suggestNetwork",
		requestTransfer: "requestTransfer",
		getAvatar: "getAvatar",
		requestSignature: "requestSignature",
		createTransaction: "createTransaction",
		addToken: "addToken",
		createEncryptionKey: "createEncryptionKey"
	};
	const ALTERNATES = {
		[WALLET_METHODS.getIdentity]: "login",
		[WALLET_METHODS.getAllAccountsFor]: "loginAll",
		[WALLET_METHODS.forgetIdentity]: "logout",
		[WALLET_METHODS.getIdentityFromPermissions]: "checkLogin"
	};
	var WalletInterface = class {
		constructor(identifier, methods, context) {
			const unavailable = (method) => () => {
				console.error(`${identifier} does not support the ${method} method.`);
				throw new Error(`${identifier} does not support the ${method} method.`);
			};
			const bindToContext = (method, key) => {
				if (typeof context[key] === "undefined") context[key] = method ? method : unavailable(key);
				if (ALTERNATES[key] && typeof context[ALTERNATES[key]] === "undefined") context[ALTERNATES[key]] = context[key] ? context[key] : unavailable(key);
			};
			Object.keys(WALLET_METHODS).map((key) => bindToContext(methods[key], key));
		}
		static bindBasics(context) {
			context.account = (blockchain) => {
				if (!context.identity) return;
				if (!context.identity.accounts) return;
				return context.identity.accounts.find((x) => x.blockchain === blockchain);
			};
		}
	};
	var WalletAPI = class {
		static getMethods(context, wallet) {
			const setAndReturnId = (id, forget) => {
				if (id || forget) context.holderFns.get().identity = id;
				return forget || id;
			};
			return {
				[WALLET_METHODS.disconnect]: () => wallet().disconnect(),
				[WALLET_METHODS.isConnected]: () => wallet().isConnected(),
				[WALLET_METHODS.isPaired]: () => wallet().isPaired(),
				[WALLET_METHODS.addEventHandler]: (handler, key = null) => wallet().addEventHandler(handler, key),
				[WALLET_METHODS.removeEventHandler]: (key = null) => wallet().removeEventHandler(key),
				[WALLET_METHODS.listen]: (handler) => wallet().addEventHandler(handler),
				[WALLET_METHODS.getVersion]: () => wallet().sendApiRequest({
					type: "getVersion",
					payload: {}
				}),
				[WALLET_METHODS.getIdentity]: (requiredFields) => wallet().sendApiRequest({
					type: "getOrRequestIdentity",
					payload: { fields: requiredFields ? requiredFields : { accounts: [context.holderFns.get().network] } }
				}).then(setAndReturnId),
				[WALLET_METHODS.getAllAccountsFor]: (requiredFields) => wallet().sendApiRequest({
					type: "getAllAccountsFor",
					payload: { fields: requiredFields ? requiredFields : { accounts: [context.holderFns.get().network] } }
				}).then(setAndReturnId),
				[WALLET_METHODS.getIdentityFromPermissions]: () => wallet().sendApiRequest({
					type: "identityFromPermissions",
					payload: {}
				}).then(setAndReturnId),
				[WALLET_METHODS.forgetIdentity]: () => wallet().sendApiRequest({
					type: "forgetIdentity",
					payload: {}
				}).then((res) => setAndReturnId(null, res)),
				[WALLET_METHODS.updateIdentity]: ({ name, kyc }) => wallet().sendApiRequest({
					type: "updateIdentity",
					payload: {
						name,
						kyc
					}
				}).then((id) => id ? setAndReturnId(id) : null),
				[WALLET_METHODS.authenticate]: (nonce, data = null, publicKey = null) => wallet().sendApiRequest({
					type: "authenticate",
					payload: {
						nonce,
						data,
						publicKey
					}
				}),
				[WALLET_METHODS.getArbitrarySignature]: (publicKey, data) => wallet().sendApiRequest({
					type: "requestArbitrarySignature",
					payload: {
						publicKey,
						data
					}
				}),
				[WALLET_METHODS.getPublicKey]: (blockchain) => wallet().sendApiRequest({
					type: "getPublicKey",
					payload: { blockchain }
				}),
				[WALLET_METHODS.linkAccount]: (account, network) => wallet().sendApiRequest({
					type: "linkAccount",
					payload: {
						account,
						network: network || context.holderFns.get().network
					}
				}),
				[WALLET_METHODS.hasAccountFor]: (network) => wallet().sendApiRequest({
					type: "hasAccountFor",
					payload: { network: network || context.holderFns.get().network }
				}),
				[WALLET_METHODS.suggestNetwork]: (network) => wallet().sendApiRequest({
					type: "requestAddNetwork",
					payload: { network: network || context.holderFns.get().network }
				}),
				[WALLET_METHODS.requestTransfer]: (network, to, amount, options = {}) => wallet().sendApiRequest({
					type: "requestTransfer",
					payload: {
						network: network || context.holderFns.get().network,
						to,
						amount,
						options
					}
				}),
				[WALLET_METHODS.getAvatar]: () => wallet().sendApiRequest({
					type: "getAvatar",
					payload: {}
				}),
				[WALLET_METHODS.requestSignature]: (payload) => wallet().sendApiRequest({
					type: "requestSignature",
					payload
				}),
				[WALLET_METHODS.createTransaction]: (blockchain, actions, account, network) => wallet().sendApiRequest({
					type: "createTransaction",
					payload: {
						blockchain,
						actions,
						account,
						network: network || context.holderFns.get().network
					}
				}),
				[WALLET_METHODS.addToken]: (token, network) => wallet().sendApiRequest({
					type: "addToken",
					payload: {
						token,
						network: network || context.holderFns.get().network
					}
				}),
				[WALLET_METHODS.createEncryptionKey]: (scatterPublicKey, otherPublicKey, nonce = null) => wallet().sendApiRequest({
					type: "createEncryptionKey",
					payload: {
						scatterPublicKey,
						otherPublicKey,
						nonce
					}
				})
			};
		}
	};
	let isAvailable$1 = false;
	if (typeof document !== "undefined") document.addEventListener("walletLoaded", () => isAvailable$1 = true);
	const checkForWallet = () => {
		if (typeof window !== "undefined" && typeof window.wallet !== "undefined") {
			isAvailable$1 = true;
			return true;
		}
		return false;
	};
	const pollExistence$1 = async (resolver = null, tries = 0) => {
		return new Promise((r) => {
			if (!resolver) resolver = r;
			if (isAvailable$1 || checkForWallet()) return resolver(true);
			if (tries > 5) return resolver(false);
			setTimeout(() => pollExistence$1(resolver, tries + 1), 100);
		});
	};
	var Injection = class extends Plugin {
		constructor(context, holderFns) {
			super("InjectedWalletV2", WALLET_SUPPORT);
			this.name = "InjectedWalletV2";
			this.context = context;
			this.holderFns = holderFns;
		}
		async connect() {
			return new Promise(async (resolve) => {
				if (await pollExistence$1()) {
					if (this.holderFns && !this.holderFns.get().wallet) this.holderFns.get().wallet = this.name;
					resolve({
						disconnect: () => {},
						sendApiRequest: window.wallet.sendApiRequest
					});
				}
			});
		}
		async runAfterInterfacing() {
			this.holderFns.get().identity = await this.holderFns.get().getIdentityFromPermissions();
			return true;
		}
		methods() {
			return WalletAPI.getMethods(this, () => window.wallet);
		}
	};
	var Network = class Network {
		constructor(_name = "", _protocol = "https", _host = "", _port = 0, blockchain = Blockchains.EOS, chainId = "") {
			this.name = _name;
			this.protocol = _protocol;
			this.host = _host;
			this.port = _port;
			this.blockchain = blockchain;
			this.chainId = chainId.toString();
			this.token = null;
		}
		static placeholder() {
			return new Network();
		}
		static fromJson(json) {
			const p = Object.assign(Network.placeholder(), json);
			p.chainId = p.chainId ? p.chainId.toString() : "";
			p.token = json.hasOwnProperty("token") && json.token ? Token.fromJson(json.token) : null;
			return p;
		}
		fullhost() {
			return `${this.protocol}://${this.host}${this.port ? ":" : ""}${this.port}`;
		}
		unique() {
			return (`${this.blockchain}:` + (this.chainId.length ? `chain:${this.chainId}` : `${this.host}:${this.port}`)).toLowerCase();
		}
	};
	let storage = {};
	const getWindow = () => {
		if (typeof window !== "undefined") return window;
		return { localStorage: {
			setItem: (key, val) => storage[key] = val,
			getItem: (key) => storage[key] || null,
			removeItem: (key) => delete storage[key]
		} };
	};
	var StorageService = class {
		constructor() {}
		static setAppKey(appkey) {
			getWindow().localStorage.setItem("appkey", appkey);
		}
		static getAppKey() {
			return getWindow().localStorage.getItem("appkey");
		}
		static removeAppKey() {
			return getWindow().localStorage.removeItem("appkey");
		}
		static setNonce(nonce) {
			getWindow().localStorage.setItem("nonce", nonce);
		}
		static getNonce() {
			return getWindow().localStorage.getItem("nonce");
		}
		static removeNonce() {
			return getWindow().localStorage.removeItem("nonce");
		}
	};
	var IS_BOT_REGEXP = new RegExp("^.*(" + [
		"\\+https:\\/\\/developers.google.com\\/\\+\\/web\\/snippet\\/",
		"googlebot",
		"baiduspider",
		"gurujibot",
		"yandexbot",
		"slurp",
		"msnbot",
		"bingbot",
		"facebookexternalhit",
		"linkedinbot",
		"twitterbot",
		"slackbot",
		"telegrambot",
		"applebot",
		"pingdom",
		"tumblr ",
		"Embedly",
		"spbot"
	].join("|") + ").*$");
	var DeviceUUID = function(options) {
		options = options ? options : {};
		var defOptions = {
			version: false,
			language: false,
			platform: true,
			os: true,
			pixelDepth: true,
			colorDepth: true,
			resolution: false,
			isAuthoritative: true,
			silkAccelerated: true,
			isKindleFire: true,
			isDesktop: true,
			isMobile: true,
			isTablet: true,
			isWindows: true,
			isLinux: true,
			isLinux64: true,
			isChromeOS: true,
			isMac: true,
			isiPad: true,
			isiPhone: true,
			isiPod: true,
			isAndroid: true,
			isSamsung: true,
			isSmartTV: true,
			isRaspberry: true,
			isBlackberry: true,
			isTouchScreen: true,
			isOpera: false,
			isIE: false,
			isEdge: false,
			isIECompatibilityMode: false,
			isSafari: false,
			isFirefox: false,
			isWebkit: false,
			isChrome: false,
			isKonqueror: false,
			isOmniWeb: false,
			isSeaMonkey: false,
			isFlock: false,
			isAmaya: false,
			isPhantomJS: false,
			isEpiphany: false,
			source: false,
			cpuCores: false
		};
		for (var key in options) if (options.hasOwnProperty(key) && typeof defOptions[key] !== "undefined") defOptions[key] = options[key];
		this.options = defOptions;
		this.version = "1.0.0";
		this._Versions = {
			Edge: /Edge\/([\d\w\.\-]+)/i,
			Firefox: /firefox\/([\d\w\.\-]+)/i,
			IE: /msie\s([\d\.]+[\d])|trident\/\d+\.\d+;.*[rv:]+(\d+\.\d)/i,
			Chrome: /chrome\/([\d\w\.\-]+)/i,
			Chromium: /(?:chromium|crios)\/([\d\w\.\-]+)/i,
			Safari: /version\/([\d\w\.\-]+)/i,
			Opera: /version\/([\d\w\.\-]+)|OPR\/([\d\w\.\-]+)/i,
			Ps3: /([\d\w\.\-]+)\)\s*$/i,
			Psp: /([\d\w\.\-]+)\)?\s*$/i,
			Amaya: /amaya\/([\d\w\.\-]+)/i,
			SeaMonkey: /seamonkey\/([\d\w\.\-]+)/i,
			OmniWeb: /omniweb\/v([\d\w\.\-]+)/i,
			Flock: /flock\/([\d\w\.\-]+)/i,
			Epiphany: /epiphany\/([\d\w\.\-]+)/i,
			WinJs: /msapphost\/([\d\w\.\-]+)/i,
			PhantomJS: /phantomjs\/([\d\w\.\-]+)/i,
			UC: /UCBrowser\/([\d\w\.]+)/i
		};
		this._Browsers = {
			Edge: /edge/i,
			Amaya: /amaya/i,
			Konqueror: /konqueror/i,
			Epiphany: /epiphany/i,
			SeaMonkey: /seamonkey/i,
			Flock: /flock/i,
			OmniWeb: /omniweb/i,
			Chromium: /chromium|crios/i,
			Chrome: /chrome/i,
			Safari: /safari/i,
			IE: /msie|trident/i,
			Opera: /opera|OPR/i,
			PS3: /playstation 3/i,
			PSP: /playstation portable/i,
			Firefox: /firefox/i,
			WinJs: /msapphost/i,
			PhantomJS: /phantomjs/i,
			UC: /UCBrowser/i
		};
		this._OS = {
			Windows10: /windows nt 10\.0/i,
			Windows81: /windows nt 6\.3/i,
			Windows8: /windows nt 6\.2/i,
			Windows7: /windows nt 6\.1/i,
			UnknownWindows: /windows nt 6\.\d+/i,
			WindowsVista: /windows nt 6\.0/i,
			Windows2003: /windows nt 5\.2/i,
			WindowsXP: /windows nt 5\.1/i,
			Windows2000: /windows nt 5\.0/i,
			WindowsPhone8: /windows phone 8\./,
			OSXCheetah: /os x 10[._]0/i,
			OSXPuma: /os x 10[._]1(\D|$)/i,
			OSXJaguar: /os x 10[._]2/i,
			OSXPanther: /os x 10[._]3/i,
			OSXTiger: /os x 10[._]4/i,
			OSXLeopard: /os x 10[._]5/i,
			OSXSnowLeopard: /os x 10[._]6/i,
			OSXLion: /os x 10[._]7/i,
			OSXMountainLion: /os x 10[._]8/i,
			OSXMavericks: /os x 10[._]9/i,
			OSXYosemite: /os x 10[._]10/i,
			OSXElCapitan: /os x 10[._]11/i,
			OSXSierra: /os x 10[._]12/i,
			Mac: /os x/i,
			Linux: /linux/i,
			Linux64: /linux x86_64/i,
			ChromeOS: /cros/i,
			Wii: /wii/i,
			PS3: /playstation 3/i,
			PSP: /playstation portable/i,
			iPad: /\(iPad.*os (\d+)[._](\d+)/i,
			iPhone: /\(iPhone.*os (\d+)[._](\d+)/i,
			Bada: /Bada\/(\d+)\.(\d+)/i,
			Curl: /curl\/(\d+)\.(\d+)\.(\d+)/i
		};
		this._Platform = {
			Windows: /windows nt/i,
			WindowsPhone: /windows phone/i,
			Mac: /macintosh/i,
			Linux: /linux/i,
			Wii: /wii/i,
			Playstation: /playstation/i,
			iPad: /ipad/i,
			iPod: /ipod/i,
			iPhone: /iphone/i,
			Android: /android/i,
			Blackberry: /blackberry/i,
			Samsung: /samsung/i,
			Curl: /curl/i
		};
		this.DefaultAgent = {
			isAuthoritative: true,
			isMobile: false,
			isTablet: false,
			isiPad: false,
			isiPod: false,
			isiPhone: false,
			isAndroid: false,
			isBlackberry: false,
			isOpera: false,
			isIE: false,
			isEdge: false,
			isIECompatibilityMode: false,
			isSafari: false,
			isFirefox: false,
			isWebkit: false,
			isChrome: false,
			isKonqueror: false,
			isOmniWeb: false,
			isSeaMonkey: false,
			isFlock: false,
			isAmaya: false,
			isPhantomJS: false,
			isEpiphany: false,
			isDesktop: false,
			isWindows: false,
			isLinux: false,
			isLinux64: false,
			isMac: false,
			isChromeOS: false,
			isBada: false,
			isSamsung: false,
			isRaspberry: false,
			isBot: false,
			isCurl: false,
			isAndroidTablet: false,
			isWinJs: false,
			isKindleFire: false,
			isSilk: false,
			isCaptive: false,
			isSmartTV: false,
			isUC: false,
			isTouchScreen: false,
			silkAccelerated: false,
			colorDepth: -1,
			pixelDepth: -1,
			resolution: [],
			cpuCores: -1,
			language: "unknown",
			browser: "unknown",
			version: "unknown",
			os: "unknown",
			platform: "unknown",
			geoIp: {},
			source: "",
			hashInt: function(string) {
				var hash = 0, i, chr, len;
				if (string.length === 0) return hash;
				for (i = 0, len = string.length; i < len; i++) {
					chr = string.charCodeAt(i);
					hash = (hash << 5) - hash + chr;
					hash |= 0;
				}
				return hash;
			},
			hashMD5: function(string) {
				function rotateLeft(lValue, iShiftBits) {
					return lValue << iShiftBits | lValue >>> 32 - iShiftBits;
				}
				function addUnsigned(lX, lY) {
					var lX4, lY4, lX8 = lX & 2147483648, lY8 = lY & 2147483648, lResult;
					lX4 = lX & 1073741824;
					lY4 = lY & 1073741824;
					lResult = (lX & 1073741823) + (lY & 1073741823);
					if (lX4 & lY4) return lResult ^ 2147483648 ^ lX8 ^ lY8;
					if (lX4 | lY4) {
						if (lResult & 1073741824) return lResult ^ 3221225472 ^ lX8 ^ lY8;
						else return lResult ^ 1073741824 ^ lX8 ^ lY8;
					} else return lResult ^ lX8 ^ lY8;
				}
				function gF(x, y, z) {
					return x & y | ~x & z;
				}
				function gG(x, y, z) {
					return x & z | y & ~z;
				}
				function gH(x, y, z) {
					return x ^ y ^ z;
				}
				function gI(x, y, z) {
					return y ^ (x | ~z);
				}
				function gFF(a, b, c, d, x, s, ac) {
					a = addUnsigned(a, addUnsigned(addUnsigned(gF(b, c, d), x), ac));
					return addUnsigned(rotateLeft(a, s), b);
				}
				function gGG(a, b, c, d, x, s, ac) {
					a = addUnsigned(a, addUnsigned(addUnsigned(gG(b, c, d), x), ac));
					return addUnsigned(rotateLeft(a, s), b);
				}
				function gHH(a, b, c, d, x, s, ac) {
					a = addUnsigned(a, addUnsigned(addUnsigned(gH(b, c, d), x), ac));
					return addUnsigned(rotateLeft(a, s), b);
				}
				function gII(a, b, c, d, x, s, ac) {
					a = addUnsigned(a, addUnsigned(addUnsigned(gI(b, c, d), x), ac));
					return addUnsigned(rotateLeft(a, s), b);
				}
				function convertToWordArray(string) {
					var lWordCount;
					var lMessageLength = string.length;
					var lNumberOfWordsTemp1 = lMessageLength + 8;
					var lNumberOfWords = ((lNumberOfWordsTemp1 - lNumberOfWordsTemp1 % 64) / 64 + 1) * 16;
					var lWordArray = new Array(lNumberOfWords - 1);
					var lBytePosition = 0;
					var lByteCount = 0;
					while (lByteCount < lMessageLength) {
						lWordCount = (lByteCount - lByteCount % 4) / 4;
						lBytePosition = lByteCount % 4 * 8;
						lWordArray[lWordCount] = lWordArray[lWordCount] | string.charCodeAt(lByteCount) << lBytePosition;
						lByteCount++;
					}
					lWordCount = (lByteCount - lByteCount % 4) / 4;
					lBytePosition = lByteCount % 4 * 8;
					lWordArray[lWordCount] = lWordArray[lWordCount] | 128 << lBytePosition;
					lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
					lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
					return lWordArray;
				}
				function wordToHex(lValue) {
					var wordToHexValue = "", wordToHexValueTemp = "", lByte, lCount;
					for (lCount = 0; lCount <= 3; lCount++) {
						lByte = lValue >>> lCount * 8 & 255;
						wordToHexValueTemp = "0" + lByte.toString(16);
						wordToHexValue = wordToHexValue + wordToHexValueTemp.substr(wordToHexValueTemp.length - 2, 2);
					}
					return wordToHexValue;
				}
				function utf8Encode(string) {
					string = string.replace(/\r\n/g, "\n");
					var utftext = "";
					for (var n = 0; n < string.length; n++) {
						var c = string.charCodeAt(n);
						if (c < 128) utftext += String.fromCharCode(c);
						else if (c > 127 && c < 2048) {
							utftext += String.fromCharCode(c >> 6 | 192);
							utftext += String.fromCharCode(c & 63 | 128);
						} else {
							utftext += String.fromCharCode(c >> 12 | 224);
							utftext += String.fromCharCode(c >> 6 & 63 | 128);
							utftext += String.fromCharCode(c & 63 | 128);
						}
					}
					return utftext;
				}
				var x = [];
				var k, AA, BB, CC, DD, a, b, c, d;
				var S11 = 7, S12 = 12, S13 = 17, S14 = 22;
				var S21 = 5, S22 = 9, S23 = 14, S24 = 20;
				var S31 = 4, S32 = 11, S33 = 16, S34 = 23;
				var S41 = 6, S42 = 10, S43 = 15, S44 = 21;
				string = utf8Encode(string);
				x = convertToWordArray(string);
				a = 1732584193;
				b = 4023233417;
				c = 2562383102;
				d = 271733878;
				for (k = 0; k < x.length; k += 16) {
					AA = a;
					BB = b;
					CC = c;
					DD = d;
					a = gFF(a, b, c, d, x[k + 0], S11, 3614090360);
					d = gFF(d, a, b, c, x[k + 1], S12, 3905402710);
					c = gFF(c, d, a, b, x[k + 2], S13, 606105819);
					b = gFF(b, c, d, a, x[k + 3], S14, 3250441966);
					a = gFF(a, b, c, d, x[k + 4], S11, 4118548399);
					d = gFF(d, a, b, c, x[k + 5], S12, 1200080426);
					c = gFF(c, d, a, b, x[k + 6], S13, 2821735955);
					b = gFF(b, c, d, a, x[k + 7], S14, 4249261313);
					a = gFF(a, b, c, d, x[k + 8], S11, 1770035416);
					d = gFF(d, a, b, c, x[k + 9], S12, 2336552879);
					c = gFF(c, d, a, b, x[k + 10], S13, 4294925233);
					b = gFF(b, c, d, a, x[k + 11], S14, 2304563134);
					a = gFF(a, b, c, d, x[k + 12], S11, 1804603682);
					d = gFF(d, a, b, c, x[k + 13], S12, 4254626195);
					c = gFF(c, d, a, b, x[k + 14], S13, 2792965006);
					b = gFF(b, c, d, a, x[k + 15], S14, 1236535329);
					a = gGG(a, b, c, d, x[k + 1], S21, 4129170786);
					d = gGG(d, a, b, c, x[k + 6], S22, 3225465664);
					c = gGG(c, d, a, b, x[k + 11], S23, 643717713);
					b = gGG(b, c, d, a, x[k + 0], S24, 3921069994);
					a = gGG(a, b, c, d, x[k + 5], S21, 3593408605);
					d = gGG(d, a, b, c, x[k + 10], S22, 38016083);
					c = gGG(c, d, a, b, x[k + 15], S23, 3634488961);
					b = gGG(b, c, d, a, x[k + 4], S24, 3889429448);
					a = gGG(a, b, c, d, x[k + 9], S21, 568446438);
					d = gGG(d, a, b, c, x[k + 14], S22, 3275163606);
					c = gGG(c, d, a, b, x[k + 3], S23, 4107603335);
					b = gGG(b, c, d, a, x[k + 8], S24, 1163531501);
					a = gGG(a, b, c, d, x[k + 13], S21, 2850285829);
					d = gGG(d, a, b, c, x[k + 2], S22, 4243563512);
					c = gGG(c, d, a, b, x[k + 7], S23, 1735328473);
					b = gGG(b, c, d, a, x[k + 12], S24, 2368359562);
					a = gHH(a, b, c, d, x[k + 5], S31, 4294588738);
					d = gHH(d, a, b, c, x[k + 8], S32, 2272392833);
					c = gHH(c, d, a, b, x[k + 11], S33, 1839030562);
					b = gHH(b, c, d, a, x[k + 14], S34, 4259657740);
					a = gHH(a, b, c, d, x[k + 1], S31, 2763975236);
					d = gHH(d, a, b, c, x[k + 4], S32, 1272893353);
					c = gHH(c, d, a, b, x[k + 7], S33, 4139469664);
					b = gHH(b, c, d, a, x[k + 10], S34, 3200236656);
					a = gHH(a, b, c, d, x[k + 13], S31, 681279174);
					d = gHH(d, a, b, c, x[k + 0], S32, 3936430074);
					c = gHH(c, d, a, b, x[k + 3], S33, 3572445317);
					b = gHH(b, c, d, a, x[k + 6], S34, 76029189);
					a = gHH(a, b, c, d, x[k + 9], S31, 3654602809);
					d = gHH(d, a, b, c, x[k + 12], S32, 3873151461);
					c = gHH(c, d, a, b, x[k + 15], S33, 530742520);
					b = gHH(b, c, d, a, x[k + 2], S34, 3299628645);
					a = gII(a, b, c, d, x[k + 0], S41, 4096336452);
					d = gII(d, a, b, c, x[k + 7], S42, 1126891415);
					c = gII(c, d, a, b, x[k + 14], S43, 2878612391);
					b = gII(b, c, d, a, x[k + 5], S44, 4237533241);
					a = gII(a, b, c, d, x[k + 12], S41, 1700485571);
					d = gII(d, a, b, c, x[k + 3], S42, 2399980690);
					c = gII(c, d, a, b, x[k + 10], S43, 4293915773);
					b = gII(b, c, d, a, x[k + 1], S44, 2240044497);
					a = gII(a, b, c, d, x[k + 8], S41, 1873313359);
					d = gII(d, a, b, c, x[k + 15], S42, 4264355552);
					c = gII(c, d, a, b, x[k + 6], S43, 2734768916);
					b = gII(b, c, d, a, x[k + 13], S44, 1309151649);
					a = gII(a, b, c, d, x[k + 4], S41, 4149444226);
					d = gII(d, a, b, c, x[k + 11], S42, 3174756917);
					c = gII(c, d, a, b, x[k + 2], S43, 718787259);
					b = gII(b, c, d, a, x[k + 9], S44, 3951481745);
					a = addUnsigned(a, AA);
					b = addUnsigned(b, BB);
					c = addUnsigned(c, CC);
					d = addUnsigned(d, DD);
				}
				return (wordToHex(a) + wordToHex(b) + wordToHex(c) + wordToHex(d)).toLowerCase();
			}
		};
		this.Agent = {};
		this.getBrowser = function(string) {
			switch (true) {
				case this._Browsers.Edge.test(string):
					this.Agent.isEdge = true;
					return "Edge";
				case this._Browsers.PhantomJS.test(string):
					this.Agent.isPhantomJS = true;
					return "PhantomJS";
				case this._Browsers.Konqueror.test(string):
					this.Agent.isKonqueror = true;
					return "Konqueror";
				case this._Browsers.Amaya.test(string):
					this.Agent.isAmaya = true;
					return "Amaya";
				case this._Browsers.Epiphany.test(string):
					this.Agent.isEpiphany = true;
					return "Epiphany";
				case this._Browsers.SeaMonkey.test(string):
					this.Agent.isSeaMonkey = true;
					return "SeaMonkey";
				case this._Browsers.Flock.test(string):
					this.Agent.isFlock = true;
					return "Flock";
				case this._Browsers.OmniWeb.test(string):
					this.Agent.isOmniWeb = true;
					return "OmniWeb";
				case this._Browsers.Opera.test(string):
					this.Agent.isOpera = true;
					return "Opera";
				case this._Browsers.Chromium.test(string):
					this.Agent.isChrome = true;
					return "Chromium";
				case this._Browsers.Chrome.test(string):
					this.Agent.isChrome = true;
					return "Chrome";
				case this._Browsers.Safari.test(string):
					this.Agent.isSafari = true;
					return "Safari";
				case this._Browsers.WinJs.test(string):
					this.Agent.isWinJs = true;
					return "WinJs";
				case this._Browsers.IE.test(string):
					this.Agent.isIE = true;
					return "IE";
				case this._Browsers.PS3.test(string): return "ps3";
				case this._Browsers.PSP.test(string): return "psp";
				case this._Browsers.Firefox.test(string):
					this.Agent.isFirefox = true;
					return "Firefox";
				case this._Browsers.UC.test(string):
					this.Agent.isUC = true;
					return "UCBrowser";
				default:
					if (string.indexOf("Mozilla") !== 0 && /^([\d\w\-\.]+)\/[\d\w\.\-]+/i.test(string)) {
						this.Agent.isAuthoritative = false;
						return RegExp.$1;
					}
					return "unknown";
			}
		};
		this.getBrowserVersion = function(string) {
			var regex;
			switch (this.Agent.browser) {
				case "Edge":
					if (this._Versions.Edge.test(string)) return RegExp.$1;
					break;
				case "PhantomJS":
					if (this._Versions.PhantomJS.test(string)) return RegExp.$1;
					break;
				case "Chrome":
					if (this._Versions.Chrome.test(string)) return RegExp.$1;
					break;
				case "Chromium":
					if (this._Versions.Chromium.test(string)) return RegExp.$1;
					break;
				case "Safari":
					if (this._Versions.Safari.test(string)) return RegExp.$1;
					break;
				case "Opera":
					if (this._Versions.Opera.test(string)) return RegExp.$1 ? RegExp.$1 : RegExp.$2;
					break;
				case "Firefox":
					if (this._Versions.Firefox.test(string)) return RegExp.$1;
					break;
				case "WinJs":
					if (this._Versions.WinJs.test(string)) return RegExp.$1;
					break;
				case "IE":
					if (this._Versions.IE.test(string)) return RegExp.$2 ? RegExp.$2 : RegExp.$1;
					break;
				case "ps3":
					if (this._Versions.Ps3.test(string)) return RegExp.$1;
					break;
				case "psp":
					if (this._Versions.Psp.test(string)) return RegExp.$1;
					break;
				case "Amaya":
					if (this._Versions.Amaya.test(string)) return RegExp.$1;
					break;
				case "Epiphany":
					if (this._Versions.Epiphany.test(string)) return RegExp.$1;
					break;
				case "SeaMonkey":
					if (this._Versions.SeaMonkey.test(string)) return RegExp.$1;
					break;
				case "Flock":
					if (this._Versions.Flock.test(string)) return RegExp.$1;
					break;
				case "OmniWeb":
					if (this._Versions.OmniWeb.test(string)) return RegExp.$1;
					break;
				case "UCBrowser":
					if (this._Versions.UC.test(string)) return RegExp.$1;
					break;
				default: if (this.Agent.browser !== "unknown") {
					regex = new RegExp(this.Agent.browser + "[\\/ ]([\\d\\w\\.\\-]+)", "i");
					if (regex.test(string)) return RegExp.$1;
				}
			}
		};
		this.getOS = function(string) {
			switch (true) {
				case this._OS.WindowsVista.test(string):
					this.Agent.isWindows = true;
					return "Windows Vista";
				case this._OS.Windows7.test(string):
					this.Agent.isWindows = true;
					return "Windows 7";
				case this._OS.Windows8.test(string):
					this.Agent.isWindows = true;
					return "Windows 8";
				case this._OS.Windows81.test(string):
					this.Agent.isWindows = true;
					return "Windows 8.1";
				case this._OS.Windows10.test(string):
					this.Agent.isWindows = true;
					return "Windows 10.0";
				case this._OS.Windows2003.test(string):
					this.Agent.isWindows = true;
					return "Windows 2003";
				case this._OS.WindowsXP.test(string):
					this.Agent.isWindows = true;
					return "Windows XP";
				case this._OS.Windows2000.test(string):
					this.Agent.isWindows = true;
					return "Windows 2000";
				case this._OS.WindowsPhone8.test(string): return "Windows Phone 8";
				case this._OS.Linux64.test(string):
					this.Agent.isLinux = true;
					this.Agent.isLinux64 = true;
					return "Linux 64";
				case this._OS.Linux.test(string):
					this.Agent.isLinux = true;
					return "Linux";
				case this._OS.ChromeOS.test(string):
					this.Agent.isChromeOS = true;
					return "Chrome OS";
				case this._OS.Wii.test(string): return "Wii";
				case this._OS.PS3.test(string): return "Playstation";
				case this._OS.PSP.test(string): return "Playstation";
				case this._OS.OSXCheetah.test(string):
					this.Agent.isMac = true;
					return "OS X Cheetah";
				case this._OS.OSXPuma.test(string):
					this.Agent.isMac = true;
					return "OS X Puma";
				case this._OS.OSXJaguar.test(string):
					this.Agent.isMac = true;
					return "OS X Jaguar";
				case this._OS.OSXPanther.test(string):
					this.Agent.isMac = true;
					return "OS X Panther";
				case this._OS.OSXTiger.test(string):
					this.Agent.isMac = true;
					return "OS X Tiger";
				case this._OS.OSXLeopard.test(string):
					this.Agent.isMac = true;
					return "OS X Leopard";
				case this._OS.OSXSnowLeopard.test(string):
					this.Agent.isMac = true;
					return "OS X Snow Leopard";
				case this._OS.OSXLion.test(string):
					this.Agent.isMac = true;
					return "OS X Lion";
				case this._OS.OSXMountainLion.test(string):
					this.Agent.isMac = true;
					return "OS X Mountain Lion";
				case this._OS.OSXMavericks.test(string):
					this.Agent.isMac = true;
					return "OS X Mavericks";
				case this._OS.OSXYosemite.test(string):
					this.Agent.isMac = true;
					return "OS X Yosemite";
				case this._OS.OSXElCapitan.test(string):
					this.Agent.isMac = true;
					return "OS X El Capitan";
				case this._OS.OSXSierra.test(string):
					this.Agent.isMac = true;
					return "macOS Sierra";
				case this._OS.Mac.test(string):
					this.Agent.isMac = true;
					return "OS X";
				case this._OS.iPad.test(string):
					this.Agent.isiPad = true;
					return string.match(this._OS.iPad)[0].replace("_", ".");
				case this._OS.iPhone.test(string):
					this.Agent.isiPhone = true;
					return string.match(this._OS.iPhone)[0].replace("_", ".");
				case this._OS.Bada.test(string):
					this.Agent.isBada = true;
					return "Bada";
				case this._OS.Curl.test(string):
					this.Agent.isCurl = true;
					return "Curl";
				default: return "unknown";
			}
		};
		this.getPlatform = function(string) {
			switch (true) {
				case this._Platform.Windows.test(string): return "Microsoft Windows";
				case this._Platform.WindowsPhone.test(string):
					this.Agent.isWindowsPhone = true;
					return "Microsoft Windows Phone";
				case this._Platform.Mac.test(string): return "Apple Mac";
				case this._Platform.Curl.test(string): return "Curl";
				case this._Platform.Android.test(string):
					this.Agent.isAndroid = true;
					return "Android";
				case this._Platform.Blackberry.test(string):
					this.Agent.isBlackberry = true;
					return "Blackberry";
				case this._Platform.Linux.test(string): return "Linux";
				case this._Platform.Wii.test(string): return "Wii";
				case this._Platform.Playstation.test(string): return "Playstation";
				case this._Platform.iPad.test(string):
					this.Agent.isiPad = true;
					return "iPad";
				case this._Platform.iPod.test(string):
					this.Agent.isiPod = true;
					return "iPod";
				case this._Platform.iPhone.test(string):
					this.Agent.isiPhone = true;
					return "iPhone";
				case this._Platform.Samsung.test(string):
					this.Agent.isiSamsung = true;
					return "Samsung";
				default: return "unknown";
			}
		};
		this.testCompatibilityMode = function() {
			var ua = this;
			if (this.Agent.isIE) {
				if (/Trident\/(\d)\.0/i.test(ua.Agent.source)) {
					var tridentVersion = parseInt(RegExp.$1, 10);
					var version = parseInt(ua.Agent.version, 10);
					if (version === 7 && tridentVersion === 7) {
						ua.Agent.isIECompatibilityMode = true;
						ua.Agent.version = 11;
					}
					if (version === 7 && tridentVersion === 6) {
						ua.Agent.isIECompatibilityMode = true;
						ua.Agent.version = 10;
					}
					if (version === 7 && tridentVersion === 5) {
						ua.Agent.isIECompatibilityMode = true;
						ua.Agent.version = 9;
					}
					if (version === 7 && tridentVersion === 4) {
						ua.Agent.isIECompatibilityMode = true;
						ua.Agent.version = 8;
					}
				}
			}
		};
		this.testSilk = function() {
			var ua = this;
			switch (true) {
				case new RegExp("silk", "gi").test(ua.Agent.source): this.Agent.isSilk = true;
			}
			if (/Silk-Accelerated=true/gi.test(ua.Agent.source)) this.Agent.SilkAccelerated = true;
			return this.Agent.isSilk ? "Silk" : false;
		};
		this.testKindleFire = function() {
			var ua = this;
			switch (true) {
				case /KFOT/gi.test(ua.Agent.source):
					this.Agent.isKindleFire = true;
					return "Kindle Fire";
				case /KFTT/gi.test(ua.Agent.source):
					this.Agent.isKindleFire = true;
					return "Kindle Fire HD";
				case /KFJWI/gi.test(ua.Agent.source):
					this.Agent.isKindleFire = true;
					return "Kindle Fire HD 8.9";
				case /KFJWA/gi.test(ua.Agent.source):
					this.Agent.isKindleFire = true;
					return "Kindle Fire HD 8.9 4G";
				case /KFSOWI/gi.test(ua.Agent.source):
					this.Agent.isKindleFire = true;
					return "Kindle Fire HD 7";
				case /KFTHWI/gi.test(ua.Agent.source):
					this.Agent.isKindleFire = true;
					return "Kindle Fire HDX 7";
				case /KFTHWA/gi.test(ua.Agent.source):
					this.Agent.isKindleFire = true;
					return "Kindle Fire HDX 7 4G";
				case /KFAPWI/gi.test(ua.Agent.source):
					this.Agent.isKindleFire = true;
					return "Kindle Fire HDX 8.9";
				case /KFAPWA/gi.test(ua.Agent.source):
					this.Agent.isKindleFire = true;
					return "Kindle Fire HDX 8.9 4G";
				default: return false;
			}
		};
		this.testCaptiveNetwork = function() {
			var ua = this;
			switch (true) {
				case /CaptiveNetwork/gi.test(ua.Agent.source):
					ua.Agent.isCaptive = true;
					ua.Agent.isMac = true;
					ua.Agent.platform = "Apple Mac";
					return "CaptiveNetwork";
				default: return false;
			}
		};
		this.testMobile = function testMobile() {
			var ua = this;
			switch (true) {
				case ua.Agent.isWindows:
				case ua.Agent.isLinux:
				case ua.Agent.isMac:
				case ua.Agent.isChromeOS:
					ua.Agent.isDesktop = true;
					break;
				case ua.Agent.isAndroid:
				case ua.Agent.isSamsung:
					ua.Agent.isMobile = true;
					ua.Agent.isDesktop = false;
			}
			switch (true) {
				case ua.Agent.isiPad:
				case ua.Agent.isiPod:
				case ua.Agent.isiPhone:
				case ua.Agent.isBada:
				case ua.Agent.isBlackberry:
				case ua.Agent.isAndroid:
				case ua.Agent.isWindowsPhone:
					ua.Agent.isMobile = true;
					ua.Agent.isDesktop = false;
			}
			if (/mobile/i.test(ua.Agent.source)) {
				ua.Agent.isMobile = true;
				ua.Agent.isDesktop = false;
			}
		};
		this.testTablet = function testTablet() {
			var ua = this;
			switch (true) {
				case ua.Agent.isiPad:
				case ua.Agent.isAndroidTablet:
				case ua.Agent.isKindleFire: ua.Agent.isTablet = true;
			}
			if (/tablet/i.test(ua.Agent.source)) ua.Agent.isTablet = true;
		};
		this.testNginxGeoIP = function testNginxGeoIP(headers) {
			var ua = this;
			Object.keys(headers).forEach(function(key) {
				if (/^GEOIP/i.test(key)) ua.Agent.geoIp[key] = headers[key];
			});
		};
		this.testBot = function testBot() {
			var ua = this;
			var isBot = IS_BOT_REGEXP.exec(ua.Agent.source.toLowerCase());
			if (isBot) ua.Agent.isBot = isBot[1];
			else if (!ua.Agent.isAuthoritative) ua.Agent.isBot = /bot/i.test(ua.Agent.source);
		};
		this.testSmartTV = function testBot() {
			var ua = this;
			var isSmartTV = new RegExp("smart-tv|smarttv|googletv|appletv|hbbtv|pov_tv|netcast.tv", "gi").exec(ua.Agent.source.toLowerCase());
			if (isSmartTV) ua.Agent.isSmartTV = isSmartTV[1];
		};
		this.testAndroidTablet = function testAndroidTablet() {
			var ua = this;
			if (ua.Agent.isAndroid && !/mobile/i.test(ua.Agent.source)) ua.Agent.isAndroidTablet = true;
		};
		this.testTouchSupport = function() {
			var ua = this;
			ua.Agent.isTouchScreen = "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
		};
		this.getLaguage = function() {
			var ua = this;
			ua.Agent.language = (navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || "").toLowerCase();
		};
		this.getColorDepth = function() {
			var ua = this;
			ua.Agent.colorDepth = screen.colorDepth || -1;
		};
		this.getScreenResolution = function() {
			var ua = this;
			ua.Agent.resolution = [screen.availWidth, screen.availHeight];
		};
		this.getPixelDepth = function() {
			var ua = this;
			ua.Agent.pixelDepth = screen.pixelDepth || -1;
		};
		this.getCPU = function() {
			var ua = this;
			ua.Agent.cpuCores = navigator.hardwareConcurrency || -1;
		};
		this.reset = function reset() {
			var ua = this;
			for (var key in ua.DefaultAgent) if (ua.DefaultAgent.hasOwnProperty(key)) ua.Agent[key] = ua.DefaultAgent[key];
			return ua;
		};
		this.parse = function get(source) {
			source = source || navigator.userAgent;
			var ua = new DeviceUUID();
			ua.Agent.source = source.replace(/^\s*/, "").replace(/\s*$/, "");
			ua.Agent.os = ua.getOS(ua.Agent.source);
			ua.Agent.platform = ua.getPlatform(ua.Agent.source);
			ua.Agent.browser = ua.getBrowser(ua.Agent.source);
			ua.Agent.version = ua.getBrowserVersion(ua.Agent.source);
			ua.testBot();
			ua.testSmartTV();
			ua.testMobile();
			ua.testAndroidTablet();
			ua.testTablet();
			ua.testCompatibilityMode();
			ua.testSilk();
			ua.testKindleFire();
			ua.testCaptiveNetwork();
			ua.testTouchSupport();
			ua.getLaguage();
			ua.getColorDepth();
			ua.getPixelDepth();
			ua.getScreenResolution();
			ua.getCPU();
			return ua.Agent;
		};
		this.get = function(customData) {
			var pref = "a", du = this.parse();
			var dua = [];
			for (var key in this.options) if (this.options.hasOwnProperty(key) && this.options[key] === true) dua.push(du[key]);
			if (customData) dua.push(customData);
			if (!this.options.resolution && du.isMobile) dua.push(du.resolution);
			pref = "b";
			var tmpUuid = du.hashMD5(dua.join(":"));
			return [
				tmpUuid.slice(0, 8),
				tmpUuid.slice(8, 12),
				"4" + tmpUuid.slice(12, 15),
				pref + tmpUuid.slice(15, 18),
				tmpUuid.slice(20)
			].join("-");
		};
		this.Agent = this.DefaultAgent;
		return this;
	};
	let device;
	if (typeof navigator === "undefined" || typeof window === "undefined") device = "nodejs_env";
	else {
		const du = new DeviceUUID().parse();
		const dua = [
			du.language,
			du.platform,
			du.os,
			du.cpuCores,
			du.colorDepth
		];
		device = du.hashMD5(dua.join(":"));
	}
	var device$1 = device;
	const suffix = "/socket.io/?EIO=3&transport=websocket";
	const sha256 = (data) => createHash__default["default"]("sha256").update(data).digest("hex");
	const random = () => {
		let array = new Uint8Array(24);
		getRandomValues__default["default"](array);
		return array.join("");
	};
	var SocketService = class SocketService {
		constructor(_plugin, _timeout) {
			this.plugin = _plugin;
			this.timeout = _timeout;
			this.uuid = null;
			this.socket = null;
			this.connected = false;
			this.paired = false;
			this.openRequests = [];
			this.pairingPromise = null;
			this.eventHandlers = {};
			this.appkey = StorageService.getAppKey();
			if (!this.appkey) this.appkey = "appkey:" + random();
		}
		addEventHandler(handler, key) {
			if (!key) key = "app";
			this.eventHandlers[key] = handler;
		}
		removeEventHandler(key) {
			if (!key) key = "app";
			delete this.eventHandlers[key];
		}
		link(allowHttp = true, _uuid = null, socketHost = null) {
			this.uuid = _uuid;
			return new Promise(async (resolve) => {
				const setupSocket = () => {
					this.socket.onmessage = (msg) => {
						if (msg.data.indexOf("42/scatter") === -1) return false;
						const [type, data] = JSON.parse(msg.data.replace("42/scatter,", ""));
						if (type === "pong") return;
						if (type === "ping") return this.socket.send(`42/scatter,["pong"]`);
						switch (type) {
							case "paired": return msg_paired(data);
							case "rekey": return msg_rekey();
							case "api": return msg_api(data);
							case "event": return event_api(data);
						}
					};
					const msg_paired = (result) => {
						this.paired = result;
						if (this.paired) {
							const savedKey = StorageService.getAppKey();
							const hashed = this.appkey.indexOf("appkey:") > -1 ? sha256(this.appkey) : this.appkey;
							if (!savedKey || savedKey !== hashed) {
								StorageService.setAppKey(hashed);
								this.appkey = StorageService.getAppKey();
							}
						}
						this.pairingPromise.resolve(result);
					};
					const msg_rekey = () => {
						this.appkey = "appkey:" + random();
						this.send("rekeyed", {
							data: {
								appkey: this.appkey,
								origin: this.getOrigin()
							},
							plugin: this.plugin
						});
					};
					const msg_api = (response) => {
						try {
							response = JSON.parse(response);
						} catch (e) {}
						const openRequest = this.openRequests.find((x) => x.id === response.id);
						if (!openRequest) return;
						this.openRequests = this.openRequests.filter((x) => x.id !== response.id);
						if (typeof response.result === "object" && response.result !== null && response.result.hasOwnProperty("isError")) openRequest.reject(response.result);
						else openRequest.resolve(response.result);
					};
					const event_api = ({ event, payload }) => {
						if (Object.keys(this.eventHandlers).length) Object.keys(this.eventHandlers).map((key) => {
							this.eventHandlers[key](event, payload);
						});
					};
				};
				const getHostname = (port, ssl) => {
					if (socketHost) return socketHost;
					return ssl ? `local.get-scatter.com:${port}` : `127.0.0.1:${port}`;
				};
				const ports = await new Promise(async (portResolver) => {
					if (socketHost) return portResolver([50006]);
					const checkPort = (host, cb) => fetch(host).then((r) => r.text()).then((r) => cb(r === "scatter")).catch(() => cb(false));
					let startingPort = 50005;
					let availablePorts = [];
					const preparePorts = () => (!availablePorts.length ? [50006, 50005] : availablePorts).filter((x) => {
						if (allowHttp) return true;
						return !(x % 2);
					}).sort((a, b) => {
						return !(b % 2) ? 1 : !(a % 2) ? -1 : 0;
					});
					let returned = false;
					const resolveAndPushPort = (port = null) => {
						if (returned) return;
						returned = true;
						if (port !== null) availablePorts.push(port);
						portResolver(preparePorts());
					};
					await Promise.all([...new Array(5).keys()].map(async (i) => {
						if (returned) return;
						const _port = startingPort + i * 1500;
						await checkPort(`https://` + getHostname(_port + 1, true), (x) => x ? resolveAndPushPort(_port + 1) : null);
						if (allowHttp) await checkPort(`http://` + getHostname(_port, false), (x) => x ? resolveAndPushPort(_port) : null);
						return true;
					}));
					resolveAndPushPort();
				});
				const trySocket = (port) => new Promise((socketResolver) => {
					const ssl = !(port % 2);
					const hostname = getHostname(port, ssl);
					const protocol = ssl ? "wss://" : "ws://";
					const s = new WebSocket__default["default"](`${protocol}${hostname}${suffix}`);
					s.onerror = () => socketResolver(false);
					s.onopen = () => socketResolver(s);
				});
				let connected = false;
				for (let i = 0; i < ports.length; i++) {
					if (connected) continue;
					const s = await trySocket(ports[i]);
					if (s) {
						connected = true;
						this.socket = s;
						this.send();
						this.connected = true;
						setupSocket();
						this.pairingPromise = null;
						this.pair(true).then(() => resolve(true));
						break;
					}
				}
			});
		}
		isConnected() {
			return this.socket && this.socket.readyState === 1;
		}
		isPaired() {
			return this.paired;
		}
		disconnect() {
			if (this.socket) this.socket.close();
			return true;
		}
		sendApiRequest(request) {
			return new Promise((resolve, reject) => {
				if (request.type === "identityFromPermissions" && !this.paired) return resolve(false);
				this.pair().then(() => {
					if (!this.paired) return reject({
						code: "not_paired",
						message: "The user did not allow this app to connect to their Scatter"
					});
					request.id = random();
					request.appkey = this.appkey;
					request.nonce = StorageService.getNonce() || 0;
					const nextNonce = random();
					request.nextNonce = sha256(nextNonce);
					StorageService.setNonce(nextNonce);
					if (request.hasOwnProperty("payload") && !request.payload.hasOwnProperty("origin")) request.payload.origin = this.getOrigin();
					this.openRequests.push(Object.assign(request, {
						resolve,
						reject
					}));
					this.send("api", {
						data: request,
						plugin: this.plugin
					});
				});
			});
		}
		pair(passthrough = false) {
			return new Promise((resolve, reject) => {
				this.pairingPromise = {
					resolve,
					reject
				};
				this.send("pair", {
					data: {
						appkey: this.appkey,
						origin: this.getOrigin(),
						passthrough
					},
					plugin: this.plugin
				});
			});
		}
		send(type = null, data = null) {
			if (type === null && data === null) this.socket.send("40/scatter");
			else this.socket.send("42/scatter," + JSON.stringify([type, Object.assign(data, {
				device: device$1,
				uuid: this.uuid
			})]));
		}
		getOrigin() {
			return SocketService.getOriginOrPlugin(this.plugin);
		}
		static getOriginOrPlugin(plugin) {
			let origin;
			if (typeof location !== "undefined") if (location.hasOwnProperty("hostname") && location.hostname.length && location.hostname !== "localhost") origin = location.hostname;
			else origin = plugin;
			else origin = plugin;
			if (origin.substr(0, 4) === "www.") origin = origin.replace("www.", "");
			return origin;
		}
	};
	var LocalSocket = class extends Plugin {
		constructor(context, holderFns) {
			super("LocalSocket", WALLET_SUPPORT);
			this.name = "LocalSocket";
			this.context = context;
			this.holderFns = holderFns;
		}
		connect(pluginName, options = {}) {
			return new Promise((resolve) => {
				if (!pluginName || !pluginName.length) throw new Error("You must specify a name for this connection");
				options = Object.assign({
					linkTimeout: 3e3,
					allowHttp: true
				}, options);
				this.socketService = new SocketService(pluginName, options.linkTimeout);
				this.socketService.link(options.allowHttp).then(async (authenticated) => {
					if (!authenticated) return resolve(false);
					this.holderFns.get().isExtension = false;
					if (!this.holderFns.get().wallet) this.holderFns.get().wallet = this.name;
					return resolve(this.socketService);
				});
			});
		}
		async runAfterInterfacing() {
			this.holderFns.get().addEventHandler((t, x) => this.eventHandler(t, x), "internal");
			this.holderFns.get().identity = await this.holderFns.get().getIdentityFromPermissions();
			return true;
		}
		methods() {
			return WalletAPI.getMethods(this, () => this.socketService);
		}
		async eventHandler(event, payload) {
			switch (event) {
				case EVENTS.Disconnected:
					this.holderFns.get().identity = null;
					break;
				case EVENTS.LoggedOut: this.holderFns.get().identity = await this.holderFns.get().getIdentityFromPermissions();
			}
		}
	};
	const WEB_HOST = `https://relay.get-scatter.com:443`;
	const SOCKET_HOST = `relaysock.get-scatter.com:443`;
	var RelaySocket = class extends Plugin {
		constructor(context, holderFns) {
			super("RelaySocket", WALLET_SUPPORT);
			this.name = "RelaySocket";
			this.context = context;
			this.holderFns = holderFns;
		}
		connect(pluginName, options = {}) {
			return new Promise(async (resolve) => {
				if (!pluginName || !pluginName.length) throw new Error("You must specify a name for this connection");
				options = Object.assign({
					linkTimeout: 3e3,
					allowHttp: true
				}, options);
				const uuid = await fetch(`${WEB_HOST}/app/connect/${device$1}`).then((x) => x.status === 200 ? x.json() : null);
				if (!uuid) return resolve(false);
				this.socketService = new SocketService(pluginName, options.linkTimeout);
				this.socketService.link(options.allowHttp, uuid, SOCKET_HOST).then(async (authenticated) => {
					if (!authenticated) return resolve(false);
					this.holderFns.get().isExtension = false;
					if (!this.holderFns.get().wallet) this.holderFns.get().wallet = this.name;
					return resolve(this.socketService);
				});
			});
		}
		async runAfterInterfacing() {
			this.holderFns.get().identity = await this.holderFns.get().getIdentityFromPermissions();
			return true;
		}
		methods() {
			return LocalSocket.getMethods(this);
		}
		async eventHandler(event, payload) {
			switch (event) {
				case EVENTS.Disconnected:
					this.holderFns.get().identity = null;
					break;
				case EVENTS.LoggedOut: this.holderFns.get().identity = await this.holderFns.get().getIdentityFromPermissions();
			}
		}
	};
	let isAvailable = false;
	if (typeof window !== "undefined" && typeof document !== "undefined") {
		if (typeof window.scatter !== "undefined") isAvailable = true;
		else document.addEventListener("scatterLoaded", () => isAvailable = true);
	}
	const pollExistence = async (resolver = null, tries = 0) => {
		return new Promise((r) => {
			if (!resolver) resolver = r;
			if (isAvailable) return resolver(true);
			if (tries > 5) return resolver(false);
			setTimeout(() => pollExistence(resolver, tries + 1), 100);
		});
	};
	var LegacyInjection = class extends Plugin {
		constructor(context, holderFns) {
			super("InjectedWallet", WALLET_SUPPORT);
			this.name = "InjectedWallet";
			this.context = context;
			this.holderFns = holderFns;
		}
		async connect() {
			return new Promise(async (resolve) => {
				if (await pollExistence()) {
					if (this.holderFns && !this.holderFns.get().wallet) this.holderFns.get().wallet = this.name;
					resolve("injection");
				}
			});
		}
		async runBeforeInterfacing() {
			const network = this.context.network;
			if (network) {
				const getId = window.scatter.getIdentity.bind(window.scatter);
				const useIdentity = window.scatter.useIdentity.bind(window.scatter);
				window.scatter.getIdentity = (fields) => getId(fields ? fields : { accounts: [network] }).then((id) => {
					this.holderFns.get().identity = id;
					useIdentity(id);
					return id;
				});
				const suggest = window.scatter.suggestNetwork.bind(window.scatter);
				window.scatter.suggestNetwork = (net) => suggest(net ? net : network);
			}
			if (this.holderFns.get().wallet === this.name) window.scatter.wallet = this.name;
			this.holderFns.set(window.scatter);
			this.context = this.holderFns.get();
			return true;
		}
		async runAfterInterfacing() {
			this.context.isExtension = true;
			this.context.connect = this.connect;
			return true;
		}
		methods() {
			return {};
		}
	};
	var PluginRepositorySingleton = class {
		constructor() {
			this.plugins = [];
		}
		loadPlugin(plugin) {
			if (!this.plugin(plugin.name)) this.plugins.push(plugin);
		}
		wallets() {
			return this.plugins.filter((plugin) => plugin.type === WALLET_SUPPORT);
		}
		signatureProviders() {
			return this.plugins.filter((plugin) => plugin.type === BLOCKCHAIN_SUPPORT);
		}
		supportedBlockchains() {
			return this.signatureProviders().map((plugin) => name);
		}
		plugin(name) {
			return this.plugins.find((plugin) => plugin.name === name);
		}
		async endorsedNetworks() {
			return await Promise.all(this.signatureProviders().map(async (plugin) => await plugin.getEndorsedNetwork()));
		}
	};
	const PluginRepository = new PluginRepositorySingleton();
	const EVENTS = {
		Disconnected: "dced",
		LoggedOut: "logout"
	};
	let socket = null;
	let socketSetters = [];
	let holderFns = {};
	var ScatterJS = class {
		constructor() {
			this.identity = null;
			this.network = null;
			PluginRepository.loadPlugin(new RelaySocket(this, holderFns));
			PluginRepository.loadPlugin(new LocalSocket(this, holderFns));
			PluginRepository.loadPlugin(new Injection(this, holderFns));
			PluginRepository.loadPlugin(new LegacyInjection(this, holderFns));
		}
		loadPlugin(plugin) {
			const noIdFunc = () => {
				if (!holderFns.get().identity) throw new Error("No Identity");
			};
			if (!plugin.isValid()) throw new Error(`${plugin.name} doesn't seem to be a valid ScatterJS plugin.`);
			PluginRepository.loadPlugin(plugin);
			if (plugin.type === BLOCKCHAIN_SUPPORT) {
				this[plugin.name] = plugin.signatureProvider(noIdFunc, () => holderFns.get().identity);
				this[plugin.name + "Hook"] = plugin.hookProvider;
				if (typeof plugin.multiHook === "function") this[plugin.name + "MultiHook"] = plugin.multiHook;
				socketSetters.push(plugin.setSocketService);
			}
			if (plugin.type === WALLET_SUPPORT) plugin.init(this, holderFns, socketSetters);
		}
		async connect(pluginName, options) {
			return new Promise(async (resolve) => {
				if (!options) options = {};
				this.network = options.hasOwnProperty("network") ? options.network : null;
				const wallets = PluginRepository.wallets();
				if (socket) {
					socket.disconnect();
					socket = null;
				}
				let connected = false;
				let promises = [];
				for (let i = 0; i < wallets.length; i++) {
					if (connected) return;
					const wallet = wallets[i];
					promises.push(Promise.race([wallet.connect(pluginName, options).then(async (socketService) => {
						if (socketService) {
							if (socketService !== "injection") {
								socket = socketService;
								socketSetters.map((x) => x(socketService));
							}
							if (typeof wallet.runBeforeInterfacing === "function") await wallet.runBeforeInterfacing();
							new WalletInterface(wallet.name, wallet.methods(), holderFns.get());
							if (typeof wallet.runAfterInterfacing === "function") await wallet.runAfterInterfacing();
							WalletInterface.bindBasics(holderFns.get());
							connected = true;
							resolve(true);
						}
					}).catch(() => false), new Promise((r) => setTimeout(() => r(false), 5e3))]));
				}
				await Promise.all(promises);
				resolve(false);
			});
		}
	};
	var Holder = class {
		constructor(_scatter) {
			this.scatter = _scatter;
		}
		plugins(...plugins) {
			if (!this.scatter.isExtension) plugins.map((plugin) => this.scatter.loadPlugin(plugin));
		}
		connect(...params) {
			return this.scatter.connect(...params);
		}
		catchAll(...params) {}
	};
	let holder = new Proxy(new Holder(new ScatterJS()), { get(target, name) {
		if (typeof target[name] !== "undefined") return target[name];
		return target.scatter[name];
	} });
	holderFns.set = (s) => holder.scatter = s;
	holderFns.get = () => holder.scatter;
	if (typeof window !== "undefined") window.ScatterJS = holder;
	holder.Plugin = Plugin;
	holder.PluginTypes = PluginTypes;
	holder.Blockchains = Blockchains;
	holder.Network = Network;
	holder.Token = Token;
	holder.SocketService = SocketService;
	holder.EVENTS = EVENTS;
	holder.WalletInterface = WalletInterface;
	holder.WALLET_METHODS = WALLET_METHODS;
	let socketService = SocketService;
	const proxy = (dummy, handler) => new Proxy(dummy, handler);
	var ScatterEOS = class extends Plugin {
		constructor() {
			super(Blockchains.EOS, BLOCKCHAIN_SUPPORT);
		}
		setSocketService(_s) {
			socketService = _s;
		}
		hookProvider(network, fieldsFetcher = null) {
			network = Network.fromJson(network);
			return {
				requiredFields: {},
				getAvailableKeys: async () => {
					return await socketService.sendApiRequest({
						type: "identityFromPermissions",
						payload: {}
					}).then((id) => {
						if (!id) return [];
						return id.accounts.filter((x) => x.blockchain === Blockchains.EOS).map((x) => x.publicKey);
					});
				},
				sign: async (signargs) => {
					const requiredFields = fieldsFetcher ? fieldsFetcher() : {};
					signargs.serializedTransaction = _.Buffer.from(signargs.serializedTransaction).toString("hex");
					return new Promise(async (resolve, reject) => {
						socketService.sendApiRequest({
							type: "requestSignature",
							payload: {
								transaction: signargs,
								blockchain: Blockchains.EOS,
								network,
								requiredFields
							}
						}).then((x) => {
							resolve({
								signatures: x.signatures,
								serializedTransaction: _.Buffer.from(signargs.serializedTransaction, "hex")
							});
						}).catch((x) => reject(x));
					});
				}
			};
		}
		multiHook(network, signers) {
			const scatterSigner = this.eosHook(network);
			if (!Array.isArray(signers)) signers = [signers];
			return {
				getAvailableKeys: async () => {
					try {
						const scatterKeys = await scatterSigner.getAvailableKeys();
						let otherKeys = [];
						await Promise.all(signers.map(async (signer) => {
							await signer.getAvailableKeys().then((keys) => {
								keys.map((key) => otherKeys.push(key));
							});
							return true;
						}));
						return scatterKeys.concat(otherKeys);
					} catch (e) {
						throw new Error(e);
					}
				},
				sign: async (signargs) => {
					try {
						const serializedTransaction = _.Buffer.from(signargs.serializedTransaction, "hex");
						const individualSignArgs = async (provider) => ({
							abis: signargs.abis,
							chainId: network.chainId,
							requiredKeys: await provider.getAvailableKeys(),
							serializedTransaction
						});
						const pullOutSignatures = (result) => {
							if (typeof result === "object" && result.hasOwnProperty("signatures")) return result.signatures;
							return result;
						};
						const scatterSigs = await scatterSigner.sign(await individualSignArgs(scatterSigner)).then((x) => pullOutSignatures(x));
						let otherSigs = [];
						await Promise.all(signers.map(async (signer) => {
							await signer.sign(await individualSignArgs(signer)).then((result) => {
								pullOutSignatures(result).map((sig) => otherSigs.push(sig));
							});
							return true;
						}));
						return {
							signatures: scatterSigs.concat(otherSigs),
							serializedTransaction
						};
					} catch (e) {
						throw new Error(e);
					}
				}
			};
		}
		signatureProvider(...args) {
			args[0];
			return (network, _api, _options = {}) => {
				network = Network.fromJson(network);
				let requiredFields = {};
				const fieldsFetcher = () => requiredFields;
				const signatureProvider = this.hookProvider(network, fieldsFetcher);
				return proxy(new _api(Object.assign(_options, { signatureProvider })), { get(eosInstance, method) {
					return (...args) => {
						if (typeof eosInstance[method] === "undefined") throw new Error(`${method} does not exist on the eosjs.Api() object.`);
						const rqf = args.find((arg) => arg.hasOwnProperty("requiredFields"));
						requiredFields = rqf ? rqf.requiredFields : {};
						return eosInstance[method](...args);
					};
				} });
			};
		}
	};
	if (typeof window !== "undefined") window.ScatterEOS = ScatterEOS;
	exports.Blockchains = Blockchains;
	exports.EVENTS = EVENTS;
	exports.Network = Network;
	exports.Plugin = Plugin;
	exports.PluginTypes = PluginTypes;
	exports.ScatterEOS = ScatterEOS;
	exports.ScatterJS = holder;
	exports.SocketService = SocketService;
	exports.WALLET_METHODS = WALLET_METHODS;
	exports.WalletInterface = WalletInterface;
}));
//#endregion
export default require_scatter();

//# sourceMappingURL=scatter.js.map